(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[919],{

/***/ 26528:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[...id]",
      function () {
        return __webpack_require__(50781);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/Hydrate.mjs
var Hydrate = __webpack_require__(55464);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryClient.mjs + 4 modules
var queryClient = __webpack_require__(57634);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 2 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(91199);
// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 110 modules
var layout = __webpack_require__(37356);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/features/menu/service.ts
var service = __webpack_require__(50019);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/redux/conveyanceMode/reducer.ts
var reducer = __webpack_require__(16440);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
;// CONCATENATED MODULE: ./src/components/store/pageTitle/index.tsx










/**
 * Adds some store-specific content to the document's `<head>`.
 */ var StoreHead = function(param) {
    var routeParams = param.routeParams;
    var ref, ref1;
    var _ref = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.locations;
    }), detail = _ref.detail, locations = (0,_object_without_properties/* default */.Z)(_ref, [
        "detail"
    ]);
    var time_wanted = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr).time_wanted;
    var categories = (0,service/* useMenu */.H)({
        id: detail === null || detail === void 0 ? void 0 : detail.id,
        wantedAt: time_wanted
    }).categories;
    var seo = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    }).seo;
    // Assemble some data to build the meta tags.
    var locationsLastUpdatedAt = locations.meta.lastUpdatedAt;
    var dataObject = {
        label: detail === null || detail === void 0 ? void 0 : detail.label,
        city: detail === null || detail === void 0 ? void 0 : (ref = detail.cached_data) === null || ref === void 0 ? void 0 : ref.city,
        state: detail === null || detail === void 0 ? void 0 : (ref1 = detail.cached_data) === null || ref1 === void 0 ? void 0 : ref1.state,
        categoryName: routeParams.catName
    };
    /**
   * We're on the Product Detail page if the productId param is present.
   */ if (routeParams.productId) {
        var ref2, ref3;
        // Find the selected product.
        var product = dist/* sdkUtils.findMenuItemById */.fH.findMenuItemById(routeParams.productId, categories);
        // Assemble a data object for interpolation.
        var data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dataObject), {
            productName: product === null || product === void 0 ? void 0 : product.name,
            productDescription: product === null || product === void 0 ? void 0 : product.description,
            productImage: (product === null || product === void 0 ? void 0 : product.image) && (product === null || product === void 0 ? void 0 : product.image) === (product === null || product === void 0 ? void 0 : (ref2 = product.images) === null || ref2 === void 0 ? void 0 : ref2.image_url_1_by_1) ? product === null || product === void 0 ? void 0 : product.image : product === null || product === void 0 ? void 0 : (ref3 = product.images) === null || ref3 === void 0 ? void 0 : ref3.image_url_1_by_1
        });
        // Page title and description overrides.
        var product_page_title = seo.product_page_title, product_page_description = seo.product_page_description;
        var title = (0,stringHelpers/* interpolateIntoString */.vk)(product_page_title, data, true);
        var desc = (0,stringHelpers/* interpolateIntoString */.vk)(product_page_description, data, true);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "location:last-updated-at",
                    content: locationsLastUpdatedAt
                }, "location-last-updated-at"),
                product_page_title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: title
                        }, "og:title"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: title
                        }, "twitter:title")
                    ]
                }),
                product_page_description && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: desc
                        }, "description"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: desc
                        }, "og:description"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: desc
                        }, "twitter:description")
                    ]
                }),
                data.productImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image",
                            content: data.productImage
                        }, "og:image"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:image",
                            content: data.productImage
                        }, "twitter:image")
                    ]
                })
            ]
        });
    }
    /**
   * We're on the Store page if the productId param is absent.
   */ // Page title and description overrides.
    var store_page_title = seo.store_page_title, store_page_description = seo.store_page_description;
    var title1 = (0,stringHelpers/* interpolateIntoString */.vk)(store_page_title, dataObject, true);
    var desc1 = (0,stringHelpers/* interpolateIntoString */.vk)(store_page_description, dataObject, true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "location:last-updated-at",
                content: locationsLastUpdatedAt
            }, "location-last-updated-at"),
            store_page_title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title1
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: title1
                    }, "twitter:title")
                ]
            }),
            store_page_description && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: desc1
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: desc1
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: desc1
                    }, "twitter:description")
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants/global.ts
var global = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/constants/locations.ts
var constants_locations = __webpack_require__(56296);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ./src/components/allergens/index.ts + 2 modules
var allergens = __webpack_require__(53247);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
;// CONCATENATED MODULE: ./src/components/backToTopCTA/index.tsx





function BackToTopCTA() {
    var displayCTA = function displayCTA() {
        if (window.scrollY > 385) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };
    var scrollToTop = function scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var primary_active_color = (0,cmsConfig/* useConfigOverride */.$E)("global").primary_active_color;
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", displayCTA);
        return function() {
            window.removeEventListener("scroll", displayCTA);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
        isVisible: visible,
        onClick: scrollToTop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "20",
                height: "12",
                viewBox: "0 0 20 12",
                role: "img",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Chevron Icon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "none",
                        fillRule: "nonzero",
                        stroke: primary_active_color,
                        strokeLinecap: "round",
                        strokeWidth: "1.5",
                        d: "M18.323 10.323l-8.215-8.215-8.216 8.215"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: Label,
                accessor: "store.back_to_top_cta",
                html: true
            })
        ]
    });
}
var _primary_border_color;
var Button = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    "data-css-override": "StyledBackToTopCTA"
})(function(param) {
    var theme = param.theme, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible;
    return {
        all: "unset",
        alignItems: "center",
        backgroundColor: theme.global.body_color,
        border: "1px solid",
        borderColor: (_primary_border_color = theme.global.primary_border_color) !== null && _primary_border_color !== void 0 ? _primary_border_color : "transparent",
        boxShadow: "0px 0px 8px 0px rgb(15 15 15 / 0.19)",
        bottom: "1.25rem",
        color: theme.global.primary_active_color,
        display: "flex",
        borderRadius: "50%",
        height: "3rem",
        justifyContent: "center",
        position: "fixed",
        outline: "revert",
        right: "1.25rem",
        transform: "translateY(".concat(isVisible ? 0 : 150, "px)"),
        transition: "all 0.4s ease",
        width: "3rem",
        visibility: "hidden",
        zIndex: 10,
        "@media (min-width: 768px)": {
            visibility: "visible"
        }
    };
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5cc26eea-0"
})({
    display: "block",
    height: 0,
    overflow: "hidden",
    width: 0
});

// EXTERNAL MODULE: ./src/components/featureAccessor/index.tsx
var featureAccessor = __webpack_require__(88917);
// EXTERNAL MODULE: ./src/components/reorders/list/index.tsx + 5 modules
var list = __webpack_require__(64316);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/store/banner/styles.ts





var _background_color, _border_color;
var StyledStoreBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6715f10b-0"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: (_background_color = theme.store_banner.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        borderBottom: "1px solid ".concat((_border_color = theme.store_banner.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        padding: "20px",
        textAlign: "center"
    };
});
var StyledStoreBannerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6715f10b-1"
})(function(param) {
    var theme = param.theme;
    return {
        margin: "0 auto",
        maxWidth: "900px",
        p: (0,_object_spread/* default */.Z)({
            margin: 0
        }, (0,utils/* getFontStyles */.l)(theme.store_banner.font, {
            color: function(value) {
                return value !== null && value !== void 0 ? value : (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.store_banner.background_color);
            }
        }))
    };
});

// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
;// CONCATENATED MODULE: ./src/constants/menu.ts
var CATEGORY_NAV_DISPLAY = {
    STICKY: "sticky",
    INLINE: "inline",
    COLUMN: "column",
    LEFT: "left"
};
var CATEGORY_MENU_HEADER_DISPLAY = {
    COLUMN: "column",
    STACKED: "stacked"
};
var MOBILE_CATEGORY_NAV_DISPLAY = {
    SCROLL: "scroll",
    DROPDOWN: "dropdown"
};
var STORE_BANNER_DISPLAY;
(function(STORE_BANNER_DISPLAY) {
    STORE_BANNER_DISPLAY["NEVER"] = "never";
    STORE_BANNER_DISPLAY["ALWAYS"] = "always";
    STORE_BANNER_DISPLAY["STORE_CLOSED"] = "only_if_store_is_closed";
})(STORE_BANNER_DISPLAY || (STORE_BANNER_DISPLAY = {}));

// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
// EXTERNAL MODULE: ./src/utils/fulfillment.ts
var fulfillment = __webpack_require__(89744);
// EXTERNAL MODULE: ./src/utils/locations.ts + 2 modules
var utils_locations = __webpack_require__(52591);
;// CONCATENATED MODULE: ./src/components/store/banner/index.tsx












var StoreBanner = function() {
    var deliveryAddress = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.conveyanceMode;
    });
    var ref = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket;
    }), basketFulfillment = ref.fulfillment, basketLocation = ref.location;
    var locationDetail = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.locations.detail;
    });
    var display = (0,cmsConfig/* useConfigOverride */.$E)("store_banner").display;
    var ref1 = (0,react.useState)(false), bannerVisibility = ref1[0], setBannerVisibility = ref1[1];
    var ref2 = (0,react.useState)(null), nextOpenHours = ref2[0], setNextOpenHours = ref2[1];
    var ref3 = (0,react.useState)(dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP), orderMode = ref3[0], setOrderMode = ref3[1];
    var setBannerContent = function() {
        var ref;
        var newOrderMode = (0,fulfillment/* determineFulfillment */.P1)(deliveryAddress, // @ts-expect-error: locationDetail cannot be undefined
        locationDetail, basketLocation, basketFulfillment);
        if (newOrderMode !== orderMode) {
            setOrderMode(newOrderMode);
        }
        var locationHours = (0,utils_locations/* getOperatingHoursForLocation */.kL)(locationDetail);
        var hours = (0,utils_locations/* getNextHourSlots */.t)(locationHours);
        var openHoursDateFormat = dates/* DATE_FORMAT.HOURS_WITH_MINUTES */.z.HOURS_WITH_MINUTES;
        var offset = (locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.cached_data) ? (0,utils_dates/* getSanitizedOffset */.UG)(locationDetail.cached_data.utc_offset) : null;
        var openHours = (0,utils_locations/* deriveFormattedDateTimeString */.S2)((ref = hours[0]) === null || ref === void 0 ? void 0 : ref.start, openHoursDateFormat, /** @TODO differentiate between `null` and `undefined`. */ // @ts-expect-error
        offset);
        setNextOpenHours(openHours);
        setBannerVisibility(true);
    };
    (0,react.useEffect)(function() {
        if (display === STORE_BANNER_DISPLAY.ALWAYS || display === STORE_BANNER_DISPLAY.STORE_CLOSED && !(0,utils_locations/* isStoreCurrentlyOpen */.OM)((0,utils_locations/* getOperatingHoursForLocation */.kL)(locationDetail))) {
            setBannerContent();
        }
    });
    // Additionally checking nextOpenHours to keep from rendering $openHours$ while StringAccessor is executing
    if (bannerVisibility && nextOpenHours) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStoreBanner, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStoreBannerContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    html: true,
                    accessor: "store.banner",
                    dataObj: {
                        openHours: nextOpenHours,
                        conveyanceType: orderMode
                    },
                    tag: "p"
                })
            })
        });
    }
    return null;
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js + 1 modules
var es_redux = __webpack_require__(38726);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ./src/components/uielements/genericModal/index.tsx
var genericModal = __webpack_require__(85526);
// EXTERNAL MODULE: ./src/components/uielements/genericModal/styles.ts
var styles = __webpack_require__(61969);
// EXTERNAL MODULE: ./src/constants/checkout.ts
var checkout = __webpack_require__(80420);
// EXTERNAL MODULE: ./src/constants/events.ts
var constants_events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/redux/basket/actions.ts
var actions = __webpack_require__(29682);
// EXTERNAL MODULE: ./src/redux/conveyanceMode/actions.ts
var conveyanceMode_actions = __webpack_require__(38534);
// EXTERNAL MODULE: ./src/redux/customize/actions.ts
var customize_actions = __webpack_require__(40646);
// EXTERNAL MODULE: ./src/redux/global/actions.ts
var global_actions = __webpack_require__(79118);
// EXTERNAL MODULE: ./src/utils/basket.ts
var basket = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
// EXTERNAL MODULE: ./src/utils/events.ts
var utils_events = __webpack_require__(41762);
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
;// CONCATENATED MODULE: ./src/components/store/cartReconciliation/index.tsx





























var CartReconciliation = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CartReconciliation, Component);
    var _super = (0,_create_super/* default */.Z)(CartReconciliation);
    function CartReconciliation() {
        (0,_class_call_check/* default */.Z)(this, CartReconciliation);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            modalShown: false,
            productsNotMigrated: [],
            errorModalShown: false
        };
        _this.checkValidity = function() {
            var currentValidity = _this.props.fulfillmentModal.addressValidity;
            switch(currentValidity){
                case false:
                    _this.setState({
                        errorModalShown: true
                    });
                    return;
                case true:
                    _this.migrateBasket();
                    _this.setState({
                        errorModalShown: false
                    });
                    // KA Event
                    (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOCATION_CHANGE */.AH.LOCATION_CHANGE, {
                        name: constants_events/* MODAL.CART_MIGRATION_ACCEPTED */.zr.CART_MIGRATION_ACCEPTED,
                        // @ts-expect-error ensure that `locationDetail` is defined.
                        details: "location_name: ".concat(_this.props.locationDetail.label, ", location_id: ").concat(_this.props.locationDetail.id, ", fulfillment_change: ").concat(dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY)
                    });
                    return;
                default:
                    _this.setState({
                        errorModalShown: false
                    });
                    return;
            }
        };
        /*
   * Move the items in the cart from one store to another trying to maintain the same items while
   * switching the product and option id's.
   *
   * @param {newLocation} Location
   * @param {newLocationMenuCategories} Category[]
   */ _this.migrateBasketToNewLocation = function(newLocation, newLocationMenuCategories) {
            var _props = _this.props, basketContent = _props.basketContent, basketMenuCategories = _props.basketMenuCategories, deliveryAddress = _props.deliveryAddress, basketCreatedAt = _props.basketCreatedAt;
            var basketMigration = (0,basket/* migrateBasketItems */.HX)(basketContent.basket_items, basketMenuCategories, newLocationMenuCategories);
            _this.props.replaceBasket(basketMigration.migratedBasketItems, newLocation, newLocationMenuCategories, basketCreatedAt, // @ts-expect-error differentiate between `null` and `undefined`.
            get_default()(deliveryAddress, "address"));
            if (basketMigration.productsNotMatched.length) {
                _this.setState({
                    productsNotMigrated: basketMigration.productsNotMatched
                });
                // KA Event
                (0,utils_events/* fireGenericOrderEventsHandler */.CK)(constants_events/* K_ANALYTICS_EVENTS.ITEMS_NOT_AVAILABLE */.AH.ITEMS_NOT_AVAILABLE, basketContent, null, [
                    constants_events/* BASKET_ORDER_KEYS.BASKET_PRODUCTS */.oO.BASKET_PRODUCTS
                ]);
            }
            (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.STORE__BASKET_RECONCILIATION */.x.STORE__BASKET_RECONCILIATION, {
                name: deliveryAddress.type || dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP,
                details: basketMigration.productsNotMatched.length ? "products_removed" : "no_removals"
            });
        };
        _this.migrateBasket = function() {
            var _props = _this.props, basketLocation = _props.basketLocation, menuCategories = _props.menuCategories, locationDetail = _props.locationDetail, setCartMigration = _props.setCartMigration, setProduct = _props.setProduct;
            var pendingItem = get_default()(_this.props, "cartMigration.pendingItem");
            // @ts-expect-error ensure that `locationDetail` is defined.
            _this.migrateBasketToNewLocation(locationDetail, menuCategories);
            setCartMigration();
            if (pendingItem) {
                setProduct({
                    product: pendingItem,
                    menuCategories: menuCategories,
                    label: checkout/* PRODUCT_LOCATION_LABELS.MENU */.X.MENU
                });
            }
            // GA Event
            (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.findShop */.m1.findShop, googleAnalytics/* gaActions.changeLocation */.cE.changeLocation, {
                // @ts-expect-error ensure that `locationDetail` is defined.
                label: "".concat(basketLocation.label, " to ").concat(locationDetail.label)
            });
        };
        _this.resetBasket = function() {
            var _props = _this.props, setCartMigration = _props.setCartMigration, setProduct = _props.setProduct, menuCategories = _props.menuCategories;
            // TODO: add types for cartMigration.pendingItem
            var pendingItem = get_default()(_this.props, "cartMigration.pendingItem");
            setCartMigration();
            setProduct({
                product: pendingItem,
                menuCategories: menuCategories,
                label: checkout/* PRODUCT_LOCATION_LABELS.MENU */.X.MENU
            });
        };
        _this.checkCartLocation = function() {
            var _props = _this.props, basketLocation = _props.basketLocation, cartMigration = _props.cartMigration, locationDetail = _props.locationDetail, locationsLoading = _props.locationsLoading, menuLoading = _props.menuLoading, setCartMigration = _props.setCartMigration;
            var modalShown = _this.state.modalShown;
            // Pass if we're already displaying the modal or if the modal has already been shown
            if (cartMigration.type || modalShown) {
                return;
            }
            // Test conditions when to present cart to new location migration modal
            if ((locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.id) && basketLocation.id && !locationsLoading && !menuLoading) {
                if ((locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.id) !== basketLocation.id) {
                    setCartMigration(constants_locations/* CART_MIGRATION_TYPES.MIGRATE */.Jl.MIGRATE);
                }
            }
        };
        return _this;
    }
    var _proto = CartReconciliation.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.checkCartLocation();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var currentValidity = this.props.fulfillmentModal.addressValidity;
        if (this.props.cartMigration.type && !prevProps.cartMigration.type) {
            this.setState({
                modalShown: true
            });
            return;
        }
        /* If we change delivery locations, need to revalidate address -
     * If not valid, display error modal, else migrate basket and fire analytics event
     */ if (currentValidity !== prevProps.fulfillmentModal.addressValidity && !this.props.fulfillmentModal.display) {
            this.checkValidity();
        }
        this.checkCartLocation();
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, router = _props.router, basketContent = _props.basketContent, basketLocation = _props.basketLocation, cartMigration = _props.cartMigration, locationDetail = _props.locationDetail, setCartMigration = _props.setCartMigration, basketFulfillment = _props.basketFulfillment, clearDeliveryAddress = _props.clearDeliveryAddress, checkDeliveryAddress = _props.checkDeliveryAddress, fulfillmentModal = _props.fulfillmentModal, toggleFulfillmentModal = _props.toggleFulfillmentModal;
        var _state = this.state, productsNotMigrated = _state.productsNotMigrated, errorModalShown = _state.errorModalShown;
        var deliveryOnlyLocation = locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.is_delivery_only;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(genericModal/* default */.Z, {
                    modalOpen: !!cartMigration.type && !errorModalShown,
                    toggleModal: function() {
                        return setCartMigration();
                    },
                    name: constants_events/* MODAL.CART_MIGRATION_MODAL */.zr.CART_MIGRATION_MODAL,
                    disableModalClose: deliveryOnlyLocation,
                    header: "Your current order is set for ".concat(basketFulfillment === null || basketFulfillment === void 0 ? void 0 : basketFulfillment.type, " from ").concat(basketLocation.label),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledGenericModalContent */.iC, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                style: {
                                    padding: 20
                                },
                                children: [
                                    "Please confirm you would like to update your order to our",
                                    " ",
                                    locationDetail.label,
                                    " store."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledGenericModalFooter */.vy, {
                            children: [
                                basketFulfillment && basketFulfillment.address ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        !deliveryOnlyLocation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledAlertCta */.dK, {
                                            size: "large",
                                            // @ts-expect-error ensure that `locationDetail` is defined.
                                            "aria-label": "Pickup from ".concat(locationDetail.label),
                                            onClick: function() {
                                                _this.migrateBasket();
                                                // @ts-expect-error ensure that `locationDetail` is defined.
                                                clearDeliveryAddress(locationDetail.id);
                                                // KA Event
                                                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOCATION_CHANGE */.AH.LOCATION_CHANGE, {
                                                    name: constants_events/* MODAL.CART_MIGRATION_ACCEPTED */.zr.CART_MIGRATION_ACCEPTED,
                                                    // @ts-expect-error ensure that `locationDetail` is defined.
                                                    details: "location_name: ".concat(locationDetail.label, ", location_id: ").concat(locationDetail.id, ", fulfillment_change: ").concat(dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP)
                                                });
                                            },
                                            children: [
                                                "Pickup from ",
                                                locationDetail.label
                                            ]
                                        }),
                                        locationDetail.supports_delivery && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledAlertCta */.dK, {
                                            size: "large",
                                            // @ts-expect-error ensure that `locationDetail` is defined.
                                            "aria-label": "Deliver from ".concat(locationDetail.label),
                                            onClick: function() {
                                                /** @TODO ensure that basketFulfillment.address is defined. */ checkDeliveryAddress(// @ts-expect-error
                                                basketFulfillment.address, locationDetail, true);
                                                _this.checkValidity();
                                            },
                                            children: [
                                                "Deliver from ",
                                                locationDetail.label
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledAlertCta */.dK, {
                                    size: "large",
                                    "aria-label": "Update order to ".concat(locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.label),
                                    onClick: function() {
                                        _this.migrateBasket();
                                        // KA Event
                                        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOCATION_CHANGE */.AH.LOCATION_CHANGE, {
                                            name: constants_events/* MODAL.CART_MIGRATION_ACCEPTED */.zr.CART_MIGRATION_ACCEPTED,
                                            details: "location_name: ".concat(locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.label, ", location_id: ").concat(locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.id)
                                        });
                                    },
                                    children: "Update Order"
                                }),
                                cartMigration.type === constants_locations/* CART_MIGRATION_TYPES.MIGRATE */.Jl.MIGRATE && (deliveryOnlyLocation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledChangeLocation */.Ik, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                toggleFulfillmentModal(true);
                                                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                                                    name: constants/* EventNames.CHANGE_LOCATION */.V.CHANGE_LOCATION,
                                                    details: constants_events/* MODAL.CART_MIGRATION_MODAL */.zr.CART_MIGRATION_MODAL
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                accessor: "cart_checkout.change_location_cta"
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSecondaryButton */.H7, {
                                    // @ts-expect-error ensure that `locationDetail` is defined.
                                    "aria-label": "Don't update order to ".concat(locationDetail.label),
                                    onClick: function() {
                                        setCartMigration();
                                        var ref, ref1;
                                        // KA Event
                                        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOCATION_CHANGE */.AH.LOCATION_CHANGE, {
                                            name: constants_events/* MODAL.CART_MIGRATION_DISMISSED */.zr.CART_MIGRATION_DISMISSED,
                                            details: "location_name: ".concat((ref = locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.label) !== null && ref !== void 0 ? ref : "", ", location_id: ").concat((ref1 = locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.id) !== null && ref1 !== void 0 ? ref1 : "")
                                        });
                                        void router.push("".concat(routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE, "/store/").concat(basketContent.location.id));
                                    },
                                    children: "Don't Update Order"
                                })),
                                cartMigration.type === constants_locations/* CART_MIGRATION_TYPES.RESET */.Jl.RESET && (deliveryOnlyLocation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledChangeLocation */.Ik, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                toggleFulfillmentModal(false);
                                                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                                                    name: constants/* EventNames.CHANGE_LOCATION */.V.CHANGE_LOCATION,
                                                    details: constants_events/* MODAL.CART_MIGRATION_MODAL */.zr.CART_MIGRATION_MODAL
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                accessor: "cart_checkout.change_location_cta"
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSecondaryButton */.H7, {
                                            onClick: function() {
                                                _this.resetBasket();
                                                // KA Event
                                                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOCATION_CHANGE */.AH.LOCATION_CHANGE, {
                                                    name: constants_events/* MODAL.CART_MIGRATION_DISMISSED */.zr.CART_MIGRATION_DISMISSED,
                                                    // @ts-expect-error ensure that `locationDetail` is defined.
                                                    details: "location_name: ".concat(locationDetail.label, ", location_id: ").concat(locationDetail.id)
                                                });
                                            },
                                            children: "Continue Without Updating"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            style: {
                                                fontStyle: "italic"
                                            },
                                            children: "Adding an item without updating the location will clear the cart before adding new items."
                                        })
                                    ]
                                }))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(genericModal/* default */.Z, {
                    modalOpen: !!productsNotMigrated.length,
                    toggleModal: function() {
                        return _this.setState({
                            productsNotMigrated: []
                        });
                    },
                    name: constants_events/* MODAL.CART_MIGRATION_NOTICES_MODAL */.zr.CART_MIGRATION_NOTICES_MODAL,
                    header: "Please check your order",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledGenericModalContent */.iC, {
                            children: productsNotMigrated.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    padding: 20,
                                    textAlign: "left"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Sorry, but the ",
                                            basketLocation.label,
                                            " location does not have the following products and they have been removed from your order:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: productsNotMigrated.map(function(product, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: product.name
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledGenericModalFooter */.vy, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSecondaryButton */.H7, {
                                "aria-label": "Got it",
                                onClick: function() {
                                    return _this.setState({
                                        productsNotMigrated: []
                                    });
                                },
                                children: "Got it"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(genericModal/* default */.Z, {
                    modalOpen: errorModalShown,
                    toggleModal: function() {
                        return _this.setState({
                            errorModalShown: false
                        });
                    },
                    name: constants_events/* MODAL.CANNOT_DELIVER_TO_ADDRESS_MODAL */.zr.CANNOT_DELIVER_TO_ADDRESS_MODAL,
                    header: "Sorry! Issue with Delivery",
                    disableModalClose: deliveryOnlyLocation,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledGenericModalContent */.iC, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    padding: 20,
                                    textAlign: "left"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: fulfillmentModal.errorMessage
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledGenericModalFooter */.vy, {
                            children: [
                                !deliveryOnlyLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledAlertCta */.dK, {
                                    size: "large",
                                    // @ts-expect-error ensure that `locationDetail` is defined.
                                    "aria-label": "Pickup from ".concat(locationDetail.label),
                                    onClick: function() {
                                        _this.migrateBasket();
                                        _this.setState({
                                            errorModalShown: false
                                        });
                                        // @ts-expect-error ensure that `locationDetail` is defined.
                                        clearDeliveryAddress(locationDetail.id);
                                        // KA Event
                                        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOCATION_CHANGE */.AH.LOCATION_CHANGE, {
                                            name: constants_events/* MODAL.CART_MIGRATION_ACCEPTED */.zr.CART_MIGRATION_ACCEPTED,
                                            // @ts-expect-error ensure that `locationDetail` is defined.
                                            details: "location_name: ".concat(locationDetail.label, ", location_id: ").concat(locationDetail.id, ", fulfillment_change: ").concat(dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP)
                                        });
                                    },
                                    children: "Switch to Pickup"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledAlertCta */.dK, {
                                    size: "large",
                                    // @ts-expect-error ensure that `locationDetail` is defined.
                                    "aria-label": "Retry Delivery from ".concat(locationDetail.label),
                                    onClick: function() {
                                        _this.setState({
                                            errorModalShown: false
                                        });
                                        setCartMigration();
                                        toggleFulfillmentModal(true, locationDetail, dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY, false, /** @TODO differentiate between `null` and `undefined`. */ // @ts-expect-error
                                        null, true, deliveryOnlyLocation);
                                        _this.checkValidity();
                                        // Log in error reporter to see if this actually happens
                                        errorReporter/* captureMessage */.uT("Delivery address or details not valid at new store location. User to re-enter info", "info", {
                                            deliveryAddress: basketFulfillment.address,
                                            // @ts-expect-error ensure that `locationDetail` is defined.
                                            storeId: locationDetail.id,
                                            basketLocationId: basketLocation.id
                                        });
                                    },
                                    children: "Re-Enter Delivery Details"
                                }),
                                deliveryOnlyLocation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledChangeLocation */.Ik, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                toggleFulfillmentModal(false);
                                                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                                                    name: constants/* EventNames.CHANGE_LOCATION */.V.CHANGE_LOCATION,
                                                    details: constants_events/* MODAL.CART_MIGRATION_NOTICES_MODAL */.zr.CART_MIGRATION_NOTICES_MODAL
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                accessor: "cart_checkout.change_location_cta"
                                            })
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSecondaryButton */.H7, {
                                    // @ts-expect-error ensure that `locationDetail` is defined.
                                    "aria-label": "Don't update order to ".concat(locationDetail.label),
                                    onClick: function() {
                                        _this.setState({
                                            errorModalShown: false
                                        });
                                        setCartMigration();
                                        // KA Event
                                        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOCATION_CHANGE */.AH.LOCATION_CHANGE, {
                                            name: constants_events/* MODAL.CART_MIGRATION_DISMISSED */.zr.CART_MIGRATION_DISMISSED,
                                            // @ts-expect-error ensure that `locationDetail` is defined.
                                            details: "location_name: ".concat(locationDetail.label, ", location_id: ").concat(locationDetail.id)
                                        });
                                    },
                                    children: "Don't Update Order"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return CartReconciliation;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        basketContent: state.app.basket.content,
        basketLocation: state.app.basket.location,
        basketCreatedAt: state.app.basket.createdAt,
        basketFulfillment: state.app.basket.fulfillment,
        cartMigration: state.app.global.cartMigration,
        deliveryAddress: state.app.conveyanceMode,
        basketMenuCategories: state.app.menu.basketMenu,
        locationDetail: state.app.locations.detail,
        locationsLoading: state.app.locations.loading,
        fulfillmentModal: state.app.global.fulfillmentModal
    };
};
var mapDispatchToProps = {
    setCartMigration: global_actions/* default.setCartMigration */.Z.setCartMigration,
    setProduct: customize_actions/* default.setProduct */.Z.setProduct,
    replaceBasket: actions/* default.replaceBasket */.Z.replaceBasket,
    checkDeliveryAddress: conveyanceMode_actions/* default.checkDeliveryAddress */.Z.checkDeliveryAddress,
    clearDeliveryAddress: conveyanceMode_actions/* default.clearDeliveryAddress */.Z.clearDeliveryAddress,
    toggleFulfillmentModal: global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal
};
var connector = (0,es.connect)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ var cartReconciliation = ((0,es_redux/* compose */.qC)(connector, next_router.withRouter)(CartReconciliation));

// EXTERNAL MODULE: ./src/constants/styles.ts
var constants_styles = __webpack_require__(30438);
// EXTERNAL MODULE: ./src/constants/tags.ts
var tags = __webpack_require__(40634);
;// CONCATENATED MODULE: ./src/utils/overflowShadow.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // Overflow shadow effect\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    background-image:\n      /* Shadows */ linear-gradient(\n        to right,\n        ",
        ",\n        ",
        "\n      ),\n      linear-gradient(to right, ",
        ", ",
        "),\n      /* Shadow covers */ linear-gradient(to right, ",
        ", ",
        "),\n      linear-gradient(to left, ",
        ", ",
        ");\n    background-position: left center, right center, left center, right center;\n    background-repeat: no-repeat;\n    background-color: ",
        ";\n    background-size: 20px 100%, 20px 100%, 20px 100%, 20px 100%;\n\n    /* Opera doesn't support this in the shorthand */\n    background-attachment: local, local, scroll, scroll;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * @param   {string|object} arg
 * @param   {object}        [breakpoints]
 * @returns {*}
 */ var overflowShadow = function(background) {
    var shadow = (0,safePolished/* safePolished */.F)(polished_esm/* transparentize */.DZ)(0.97, (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(background));
    return function() {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), background, background, background, background, shadow, background, shadow, background, background);
    };
};

;// CONCATENATED MODULE: ./src/components/store/foodHall/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  &:after {\n    background: ",
        ";\n    bottom: ",
        ';\n    content: "";\n    display: block;\n    height: 2px;\n    left: 0px;\n    position: absolute;\n    width: 100%;\n\n    @media (min-width: 768px) {\n      height: 5px;\n    }\n  }\n\n  img {\n    display: block;\n    ',
        "\n\n    @media (min-width: 768px) {\n      ",
        "\n    }\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  -webkit-overflow-scrolling: touch;\n  background: ",
        ";\n  border-bottom: solid 1px ",
        ";\n  border-top: solid 1px ",
        ";\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n  overflow-x: scroll;\n  padding: 0;\n  white-space: nowrap;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  flex-grow: 1;\n  list-style-type: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: none;\n  border: none;\n  display: ",
        ";\n  height: 80px;\n  justify-content: center;\n  margin: 0 auto;\n  width: 100%;\n\n  ",
        "\n\n  &:hover {\n    opacity: 0.8;\n    cursor: pointer;\n\n    ",
        ":after {\n      background: ",
        ";\n    }\n  }\n\n  @media (min-width: 768px) {\n    height: 125px;\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  display: flex;\n  font-size: 14px;\n  height: 50px;\n  max-width: 90px;\n  padding: ",
        "px;\n  text-align: center;\n  white-space: normal;\n\n  ",
        "\n\n  @media (min-width: 768px) {\n    font-size: 16px;\n    height: 90px;\n    max-width: 110px;\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledFilterTagImage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-fc62d545-0"
})(styles_templateObject(), function(param) {
    var active = param.active, theme = param.theme;
    return active ? "".concat(theme.buttons.primary_button_background_color) : "none";
}, function(param) {
    var location = param.location;
    return location === tags/* FILTER_TAG_LOCATION.TAKEOVER */.Z.TAKEOVER ? "-15px" : "-".concat(constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, "px");
}, function(param) {
    var location = param.location;
    return location !== tags/* FILTER_TAG_LOCATION.TAKEOVER */.Z.TAKEOVER && "\n      max-height: 50px;\n    ";
}, function(param) {
    var location = param.location;
    return location === tags/* FILTER_TAG_LOCATION.TAKEOVER */.Z.TAKEOVER ? "width: 100%;" : "max-height: 90px;";
});
var StyledFilterTagList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-fc62d545-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.food_hall.filter_nav_background_color;
}, constants_styles/* COLORS.GRAY */.DM.GRAY, constants_styles/* COLORS.GRAY */.DM.GRAY, function(param) {
    var theme = param.theme;
    return overflowShadow(theme.food_hall.filter_nav_background_color);
}, function(param) {
    var centeredTags = param.centeredTags;
    return centeredTags && "\n    display: block;\n    text-align: center;\n\n    @media (min-width: 1025px) {\n      overflow: hidden;\n    }\n\n    li {\n      vertical-align: middle;\n      width: auto;\n    }\n\n    button {\n      padding: 0 ".concat(constants_styles/* SPACING_SCALE.XS */.jl.XS, "px;\n      @supports (padding: 0 clamp(").concat(constants_styles/* SPACING_SCALE.THREEXS */.jl.THREEXS, "px, 4vw, ").concat(constants_styles/* SPACING_SCALE.LARGE */.jl.LARGE, "px)) {\n        padding: 0 clamp(").concat(constants_styles/* SPACING_SCALE.THREEXS */.jl.THREEXS, "px, 4vw, ").concat(constants_styles/* SPACING_SCALE.LARGE */.jl.LARGE, "px);\n      }\n\n      @media (min-width: 768px) {\n        min-width: 250px;\n        padding: 0 ").concat(constants_styles/* SPACING_SCALE.LARGE */.jl.LARGE, "px;\n        @supports (padding: 0 clamp(").concat(constants_styles/* SPACING_SCALE.LARGE */.jl.LARGE, "px, 6vw, 100px)) {\n          padding: 0 clamp(").concat(constants_styles/* SPACING_SCALE.LARGE */.jl.LARGE, "px, 6vw, 100px);\n        }\n      }\n    }\n  ");
});
var StyledFilterTagListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-fc62d545-2"
})(_templateObject2());
var StyledFilterTag = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-fc62d545-3"
})(_templateObject3(), function(param) {
    var location = param.location;
    return location === tags/* FILTER_TAG_LOCATION.TAKEOVER */.Z.TAKEOVER ? "block" : "flex";
}, function(param) {
    var location = param.location;
    return location !== tags/* FILTER_TAG_LOCATION.TAKEOVER */.Z.TAKEOVER && "\n    padding: 0 ".concat(constants_styles/* SPACING_SCALE.XS */.jl.XS, "px;\n  ");
}, StyledFilterTagImage, function(param) {
    var theme = param.theme;
    return theme.buttons.primary_button_background_color;
}, function(param) {
    var location = param.location;
    return location === tags/* FILTER_TAG_LOCATION.TAKEOVER */.Z.TAKEOVER ? "".concat(constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2, "px ").concat(constants_styles/* LAYOUT.GUTTER */._.GUTTER, "px") : "0 ".concat(constants_styles/* SPACING_SCALE.MEDIUM */.jl.MEDIUM, "px");
});
var StyledTagLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fc62d545-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.food_hall.filter_nav_text_color;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 4, function(param) {
    var location = param.location;
    return location === tags/* FILTER_TAG_LOCATION.TAKEOVER */.Z.TAKEOVER && "\n    min-height: 50px;\n    max-height: 90px;\n  ";
}, function(param) {
    var location = param.location;
    return location === tags/* FILTER_TAG_LOCATION.TAKEOVER */.Z.TAKEOVER && "\n      max-height: none;\n    }\n  ";
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(47661);
// EXTERNAL MODULE: ./src/services/client.ts
var services_client = __webpack_require__(49741);
// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(32210);
// EXTERNAL MODULE: ./src/utils/global.ts
var utils_global = __webpack_require__(36304);
// EXTERNAL MODULE: ./src/utils/menu.ts
var menu = __webpack_require__(682);
;// CONCATENATED MODULE: ./src/features/food-halls/service.ts











function logFoodHallError(error) {
    return _logFoodHallError.apply(this, arguments);
}
function _logFoodHallError() {
    _logFoodHallError = (0,_async_to_generator/* default */.Z)(function(error) {
        var errorResponse;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils_global/* prepareErrorMessage */.Xr)("There was an error fetching tags:", error)
                    ];
                case 1:
                    errorResponse = _state.sent();
                    (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_TAGS_ERROR */.RZ.FETCH_TAGS_ERROR, error, errorResponse);
                    return [
                        2
                    ];
            }
        });
    });
    return _logFoodHallError.apply(this, arguments);
}
function useFoodHalls() {
    var menuCategories = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var origin;
    if (true) {
        origin = (0,src_utils/* getOrigin */.P$)(window.location.host);
    } else {}
    var client = (0,services_client/* createHttpClient */.d9)({
        origin: origin
    });
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("admin"), supportsFoodHalls = ref.food_hall;
    var ref1 = (0,useQuery/* useQuery */.a)({
        queryKey: [
            "food-halls"
        ],
        queryFn: function() {
            return (0,v4/* getTags */.NJ)({
                type: "filter"
            }, {
                client: client
            });
        },
        enabled: supportsFoodHalls,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        keepPreviousData: true
    }), data = ref1.data, error = ref1.error;
    if (error) {
        void logFoodHallError(error);
    }
    return (0,menu/* filterTagsByUnavailableProducts */.JZ)(data !== null && data !== void 0 ? data : [], menuCategories);
}
var foodHallsSliceSelector = function(state) {
    return state.app.tags;
};

// EXTERNAL MODULE: ./src/redux/tags/actions.ts
var tags_actions = __webpack_require__(28799);
// EXTERNAL MODULE: ./src/utils/imageHelper.ts
var imageHelper = __webpack_require__(70595);
;// CONCATENATED MODULE: ./src/components/store/foodHall/nav.tsx










function FilterNavigation(param) {
    var menuCategories = param.menuCategories;
    var activeTagIds = (0,es.useSelector)(function(state) {
        return state.app.tags;
    }).activeTagIds;
    var dispatch = (0,es.useDispatch)();
    var router = (0,next_router.useRouter)();
    var filterTags = useFoodHalls(menuCategories);
    var shouldTagsCenter = (filterTags === null || filterTags === void 0 ? void 0 : filterTags.length) <= 3 ? true : false;
    var setActiveFilter = function() {
        if (activeTagIds) {
            return;
        }
        var filter = "";
        // Find filter tag in url query
        if (router.query.filter) {
            filter = router.query.filter.toString();
        }
        var ref;
        // Find tag by label or id
        var activeTag = (ref = filterTags.find(function(tag) {
            return tag.label === decodeURIComponent(filter) || tag.id === Number(filter);
        })) !== null && ref !== void 0 ? ref : filterTags[0];
        // Set active tag (<RouteHandler /> takes care of appending the URL query parameters)
        if (activeTag === null || activeTag === void 0 ? void 0 : activeTag.id) {
            dispatch(tags_actions/* default.setActiveTag */.Z.setActiveTag(activeTag));
        }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react.useEffect)(setActiveFilter, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react.useEffect)(setActiveFilter, [
        filterTags
    ]);
    return !activeTagIds || !filterTags.length ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFilterTagList, {
        centeredTags: shouldTagsCenter,
        children: filterTags.map(function(tag, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFilterTagListItem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFilterTag, {
                    onClick: function() {
                        // Set active tag (<RouteHandler /> takes care of appending the URL query parameters)
                        dispatch(tags_actions/* default.setActiveTag */.Z.setActiveTag(tag));
                        (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                            name: tag.label,
                            details: "Filter Tag"
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFilterTagImage, {
                        active: activeTagIds.includes(tag.id),
                        children: tag.icon_image_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,imageHelper/* resizeImage */.tg)(tag.icon_image_url, {
                                height: 100
                            }),
                            alt: tag.label
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTagLabel, {
                            children: tag.label
                        })
                    })
                })
            }, "".concat(tag.label, "-").concat(index));
        })
    });
}

;// CONCATENATED MODULE: ./src/components/store/hero/utils.ts



var getLocationHeroBackground = function(locationDetail, webConfig) {
    var resize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!locationDetail) {
        return null;
    }
    var imageSrc = (0,stringHelpers/* safelyGetConfig */.K6)(webConfig, "store_detail.background_image");
    if (locationDetail.attributes) {
        var heroAttribute = locationDetail.attributes.find(function(attribute) {
            var ref;
            return (attribute === null || attribute === void 0 ? void 0 : (ref = attribute.position) === null || ref === void 0 ? void 0 : ref.id) === constants_locations/* LOCATION_ATTRIBUTE_POSITIONS.STORE_DETAIL_HERO */.NB.STORE_DETAIL_HERO;
        });
        if (heroAttribute) {
            imageSrc = heroAttribute.value;
        }
    }
    return resize ? (0,imageHelper/* resizeImage */.tg)(imageSrc, {
        width: 2000
    }) : imageSrc;
};

;// CONCATENATED MODULE: ./src/components/store/hero/index.tsx




var StoreHero = function() {
    var webConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    });
    var locationDetail = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.locations.detail;
    });
    var background = getLocationHeroBackground(locationDetail, webConfig);
    return background ? /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_StoreBanner, {
        src: background,
        alt: "Location hero image"
    }) : null;
};
var hero_background_color;
var hero_StoreBanner = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-439b1469-0"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: (hero_background_color = theme.store_detail.background_color) !== null && hero_background_color !== void 0 ? hero_background_color : "transparent",
        display: "none",
        height: "".concat(theme.store_detail.hero_height, "px"),
        objectFit: "cover",
        width: "100%",
        "@media (min-width: 768px)": {
            display: "block"
        }
    };
});

;// CONCATENATED MODULE: ./src/components/store/layout/styles.tsx


function layout_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  div input {\n    width: 320px;\n  }\n"
    ]);
    layout_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media (min-width: 768px) {\n    display: ",
        ";\n    justify-content: flex-end;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: var(--size-3) var(--size-4);\n\n  @media (min-width: 768px) {\n    display: none;\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --bottom-store-banner__display: none;\n\n  @media (min-width: 768px) {\n    --bottom-store-banner__display: block;\n  }\n\n  bottom: 0;\n  display: var(--bottom-store-banner__display);\n  position: sticky;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledHeroMenuSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ddecd90-0"
})(layout_styles_templateObject());
var StyledMenuLayoutHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ddecd90-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    var ref, ref1;
    return ((ref = theme.menu) === null || ref === void 0 ? void 0 : ref.menu_search) || ((ref1 = theme.menu) === null || ref1 === void 0 ? void 0 : ref1.dietary_preferences_enabled) ? "flex" : "none";
});
var StyledMobileMenuSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ddecd90-2"
})(styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.store_detail.mobile_background_color;
}, function(props) {
    return props.foodHallEnabled && "\n    border-top: 1px solid ".concat(constants_styles/* COLORS.GRAY */.DM.GRAY, ";\n  ");
});
/**
 * !!HACK!!
 * The `BottomStoreBanner` and `TopStoreBanner` wrappers override the store
 * banner's positioning based on screen size to prevent a collision with
 * the "item added to cart" toast. Because the StoreBanner is included in
 * layout flow, it's actually rendered twice for "config placement bottom"
 * and the visibility is handled by the media query below.
 * - On desktop with config placement bottom, show on the bottom
 * - On mobile with config placement bottom, show on the top
 * - On desktop with config placement top, show on the top
 * - On mobile with config placement top, show on the top
 *
 * In the future, the banner should only be rendered once and positioning should
 * be handled by a CSS Grid `gridArea` so that it can be moved in the layout
 * structure without changing DOM positioning.
 */ var BottomStoreBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ddecd90-3"
})(styles_templateObject3());
var TopStoreBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ddecd90-4"
})(styles_templateObject4(), function(param) {
    var theme = param.theme;
    var ref;
    return "\n   --top-store-banner__display: block;\n\n   @media (min-width: 768px) {\n     --top-store-banner__display: ".concat(((ref = theme.store_banner) === null || ref === void 0 ? void 0 : ref.placement) === "bottom" ? "none" : "block", "\n   }\n\n  display: var(--top-store-banner__display);\n ");
});
var StyledStoreReorders = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7ddecd90-5"
})(function(param) {
    var theme = param.theme;
    return {
        ul: {
            "@media (min-width: 1025px)": {
                marginInlineEnd: "var(--neg-size-7)"
            }
        },
        h2: (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.menu_category_header.font, [
            "color"
        ])),
        a: (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.menu_category_header.secondary_font, [
            "font_size"
        ]))
    };
});

// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
;// CONCATENATED MODULE: ./src/components/store/search/styles.tsx



function search_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-color: transparent;\n  margin: 0 0 0 ",
        "px;\n  min-width: 0;\n  padding: 0 ",
        "px;\n"
    ]);
    search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  position: relative;\n\n  input {\n    height: ",
        "px;\n    padding: ",
        "px ",
        "px ",
        "px\n      ",
        "px;\n    -webkit-appearance: none;\n    width: 100%;\n\n    ",
        "\n  }\n"
    ]);
    search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  height: ",
        "px;\n  opacity: ",
        ";\n  position: absolute;\n  padding: 0 ",
        "px;\n  right: 0;\n  top: 0;\n  width: 48px;\n\n  img {\n    display: block;\n  }\n"
    ]);
    search_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function search_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: ",
        "px;\n  padding: 0 ",
        "px;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n"
    ]);
    search_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function search_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        "px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);\n  left: 0;\n  margin: 0;\n  max-height: 350px;\n  overflow: scroll;\n  padding: 0;\n  position: absolute;\n  width: 100%;\n\n  @media (max-width: 767px) {\n    box-shadow: none;\n    margin: ",
        "px -",
        "px 0;\n    height: calc(100vh - ",
        "px);\n    max-height: none;\n    padding: 0 0;\n    position: relative;\n    width: calc(100% + ",
        "px);\n  }\n\n  li {\n    border-bottom: 1px solid ",
        ";\n    list-style-type: none;\n    margin: 0 ",
        "px;\n    padding: 0;\n\n    &:last-of-type {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    search_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px ",
        "px;\n\n  h2 {\n    font-size: inherit;\n  }\n\n  h2,\n  p {\n    text-align: center !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-position: center;\n  height: ",
        "px;\n  margin: 0 ",
        "px 0 0;\n  width: ",
        "px;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var styles_background_color;
var StyledMenuSearchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-510bb02c-0"
})(function(param) {
    var theme = param.theme, modalOpen = param.modalOpen;
    return {
        backgroundColor: modalOpen ? (styles_background_color = theme.modals.background_color) !== null && styles_background_color !== void 0 ? styles_background_color : "transparent" : "transparent",
        padding: modalOpen ? ".75rem 1rem 1.5rem" : 0,
        position: modalOpen ? "fixed" : "static",
        inset: 0,
        top: "6.5rem",
        zIndex: constants_styles/* ORDER.MENU_SEARCH_MODAL */.kl.MENU_SEARCH_MODAL
    };
});
var StyledMenuSearchContainerHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-510bb02c-1"
})({
    display: "flex"
});
var StyledCancelButton = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-510bb02c-2"
})(search_styles_templateObject(), constants_styles/* SPACING_SCALE.XS */.jl.XS, constants_styles/* SPACING_SCALE.XS */.jl.XS);
var StyledMenuSearchInputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-510bb02c-3"
})(search_styles_templateObject1(), constants_styles/* LAYOUT.MENU_SEARCH_HEIGHT */._.MENU_SEARCH_HEIGHT, constants_styles/* SPACING_SCALE.XS */.jl.XS, constants_styles/* SPACING_SCALE.XL */.jl.XL, constants_styles/* SPACING_SCALE.XS */.jl.XS, constants_styles/* SPACING_SCALE.SMALL */.jl.SMALL, function(param) {
    var theme = param.theme;
    return "\n      background-color: ".concat(theme.forms.background_color, ";\n      border: 1px solid ").concat(theme.forms.border_color, ";\n      border-radius: ").concat(theme.forms.border_radius, "px;\n\n      &:focus {\n        border: 1px solid ").concat(theme.global.primary_active_color, ";\n      }\n    ");
});
var StyledClearSearch = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-510bb02c-4"
})(search_styles_templateObject2(), constants_styles/* LAYOUT.MENU_SEARCH_HEIGHT */._.MENU_SEARCH_HEIGHT, function(props) {
    return props.isVisible && 1 || 0;
}, constants_styles/* SPACING_SCALE.XS */.jl.XS);
var StyledMagnifyingGlass = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-510bb02c-5"
})(search_styles_templateObject3(), constants_styles/* LAYOUT.MENU_SEARCH_HEIGHT */._.MENU_SEARCH_HEIGHT, constants_styles/* SPACING_SCALE.SMALL */.jl.SMALL);
var mobileSearchResultHeight = constants_styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT + constants_styles/* SPACING_SCALE.SMALL */.jl.SMALL + constants_styles/* SPACING_SCALE.MEDIUM */.jl.MEDIUM + constants_styles/* LAYOUT.MENU_SEARCH_HEIGHT */._.MENU_SEARCH_HEIGHT + 2;
var StyledSearchResults = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-510bb02c-6"
})(search_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.modals.background_color;
}, function(param) {
    var theme = param.theme;
    return theme.global.border_radius;
}, constants_styles/* SPACING_SCALE.MEDIUM */.jl.MEDIUM, constants_styles/* SPACING_SCALE.SMALL */.jl.SMALL, mobileSearchResultHeight, constants_styles/* SPACING_SCALE.LARGE */.jl.LARGE, constants_styles/* COLORS.LIGHTERGRAY */.DM.LIGHTERGRAY, constants_styles/* SPACING_SCALE.SMALL */.jl.SMALL);
var StyledNoResults = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-510bb02c-7"
})(_templateObject5(), constants_styles/* LAYOUT.GUTTER */._.GUTTER, constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2);
var StyledSearchResult = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-510bb02c-8"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        background: "none",
        border: "none",
        cursor: "pointer",
        display: "flex",
        margin: "-1px -".concat(constants_styles/* SPACING_SCALE.SMALL */.jl.SMALL, "px"),
        minHeight: "".concat(constants_styles/* LAYOUT.MENU_SEARCH_RESULT_HEIGHT */._.MENU_SEARCH_RESULT_HEIGHT, "px"),
        maxWidth: "calc(100% + ".concat(constants_styles/* SPACING_SCALE.LARGE */.jl.LARGE, "px)"),
        padding: "14px ".concat(constants_styles/* SPACING_SCALE.SMALL */.jl.SMALL, "px"),
        position: "relative",
        textAlign: "left",
        width: "calc(100% + ".concat(constants_styles/* SPACING_SCALE.LARGE */.jl.LARGE, "px)")
    }, (0,utils/* getFontStyles */.l)(theme.modals.font, [
        "color"
    ])), {
        "&:hover": (0,_object_spread/* default */.Z)({
            background: theme.buttons.primary_button_background_color
        }, (0,utils/* getFontStyles */.l)(theme.buttons.primary_font, [
            "color"
        ], {
            /** @FIXME font refactor. how will this work if primary_font.color is returned as inherit | initial | etc */ color: function(value) {
                return value !== null && value !== void 0 ? value : (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.buttons.primary_button_background_color);
            }
        })),
        "@media (max-width: 767px)": (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.modals.font, [
            "color"
        ]))
    });
});
var StyledSearchResultImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-510bb02c-9"
})(_templateObject6(), constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2, function(param) {
    var backgroundImage = param.backgroundImage, theme = param.theme;
    return "\n    background-image: url(".concat(backgroundImage, ");\n    background-size: ").concat(theme.menu_product_card.image_size, ";\n  ");
});

// EXTERNAL MODULE: ./src/components/uielements/X/index.tsx
var X = __webpack_require__(66086);
// EXTERNAL MODULE: ./src/components/uielements/genericFocusTrap/index.tsx
var genericFocusTrap = __webpack_require__(38806);
;// CONCATENATED MODULE: ./src/components/uielements/hideOnScroll/styles.tsx

function hideOnScroll_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  transition: all 0.05s ease-in-out;\n  z-index: 1;\n\n  ",
        "\n"
    ]);
    hideOnScroll_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledChildren = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8724aa03-0"
})(hideOnScroll_styles_templateObject(), function(props) {
    return "\n    opacity: ".concat(props.isVisible && 1 || 0, "; \n    visibility: ").concat(props.isVisible && "visible" || "hidden", ";\n    pointer-events: ").concat(props.isVisible && "all" || "none", ";\n    transition: opacity .05s ease-in-out,\n                visibility .0s .05s;\n  ");
});

;// CONCATENATED MODULE: ./src/components/uielements/hideOnScroll/index.tsx



var HideOnScroll = function(param) {
    var onHide = param.onHide, onShow = param.onShow, children = param.children, _options = param.options, options = _options === void 0 ? {} : _options, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _style = param.style, style = _style === void 0 ? {} : _style;
    var childrenContainer = (0,react.useRef)();
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var handleShow = function() {
        setIsVisible(true);
        onShow && onShow();
    };
    var handleHide = function() {
        setIsVisible(false);
        onHide && onHide();
    };
    (0,react.useEffect)(function() {
        if (!!(window === null || window === void 0 ? void 0 : window.IntersectionObserver)) {
            var observer = new IntersectionObserver(function(entries, _observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting && !disabled) {
                        handleShow();
                    } else {
                        handleHide();
                    }
                });
            }, options);
            (childrenContainer === null || childrenContainer === void 0 ? void 0 : childrenContainer.current) && observer.observe(childrenContainer.current);
            return function() {
                observer.disconnect();
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChildren, {
        isVisible: disabled ? true : isVisible,
        // @ts-expect-error ref mismatch
        ref: childrenContainer,
        style: style,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/magnifyingGlass/index.tsx



var _MagnifyingGlassSvg = function(param) {
    var color = param.color, _size = param.size, size = _size === void 0 ? 18 : _size, theme = param.theme;
    var ref = (0,utils/* getFontStyles */.l)(theme.modals.font), fallbackColor = ref.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.53223 14.0332C8.92969 14.0332 10.2393 13.6113 11.3291 12.8906L15.1787 16.749C15.4336 16.9951 15.7588 17.1182 16.1104 17.1182C16.8398 17.1182 17.376 16.5469 17.376 15.8262C17.376 15.4922 17.2617 15.167 17.0156 14.9209L13.1924 11.0801C13.9834 9.95508 14.4492 8.59277 14.4492 7.11621C14.4492 3.31055 11.3379 0.199219 7.53223 0.199219C3.73535 0.199219 0.615234 3.31055 0.615234 7.11621C0.615234 10.9219 3.72656 14.0332 7.53223 14.0332ZM7.53223 12.1875C4.74609 12.1875 2.46094 9.90234 2.46094 7.11621C2.46094 4.33008 4.74609 2.04492 7.53223 2.04492C10.3184 2.04492 12.6035 4.33008 12.6035 7.11621C12.6035 9.90234 10.3184 12.1875 7.53223 12.1875Z",
            fill: color || fallbackColor
        })
    });
};
var MagnifyingGlassSvg = (0,styled_components_browser_esm/* withTheme */.Zz)(_MagnifyingGlassSvg);

// EXTERNAL MODULE: ./src/components/uielements/searchInput/index.tsx
var searchInput = __webpack_require__(66143);
;// CONCATENATED MODULE: ./src/components/store/search/index.tsx




















var MenuSearch = function(param) {
    var onSelect = param.onSelect, isMobile = param.isMobile;
    var ref = (0,react.useState)(""), searchTerm = ref[0], setSearchTerm = ref[1];
    var ref1 = (0,react.useState)([]), productDictionary = ref1[0], setProductDictionary = ref1[1];
    var ref2 = (0,react.useState)([]), matches = ref2[0], setMatches = ref2[1];
    var ref3 = (0,react.useState)(false), modalOpen = ref3[0], setModalOpen = ref3[1];
    var ref4 = (0,react.useState)(false), isTyping = ref4[0], setIsTyping = ref4[1];
    var detail = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.locations;
    }).detail;
    var strings = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.strings;
    });
    var time_wanted = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr).time_wanted;
    var food_hall = (0,cmsConfig/* useConfigOverride */.$E)("admin").food_hall;
    var ref5 = (0,service/* useMenu */.H)({
        id: detail === null || detail === void 0 ? void 0 : detail.id,
        wantedAt: time_wanted
    }), categories = ref5.categories, status = ref5.status;
    var filteredCategories = categories.filter(function(category) {
        return category.products.length;
    });
    (0,react.useEffect)(function() {
        var productDict = dist/* sdkUtils.createMenuProductDictionary */.fH.createMenuProductDictionary(filteredCategories, food_hall);
        setProductDictionary(productDict);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        categories
    ]);
    (0,react.useEffect)(function() {
        var searchTimeout = setTimeout(function() {
            searchAnalytics();
        }, 1000);
        return function() {
            return clearTimeout(searchTimeout);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchTerm,
        matches
    ]);
    (0,react.useEffect)(function() {
        setIsTyping(true);
        var typingTimeout = setTimeout(function() {
            findMatches(searchTerm);
            setIsTyping(false);
        }, 500);
        return function() {
            clearTimeout(typingTimeout);
            setIsTyping(true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchTerm
    ]);
    var searchAnalytics = function() {
        if (!searchTerm) {
            return;
        }
        (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.browse */.m1.browse, googleAnalytics/* gaActions.menuSearch */.cE.menuSearch, {
            label: searchTerm
        });
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.MENU_SEARCH */.AH.MENU_SEARCH, {
            name: searchTerm,
            details: matches.map(function(match) {
                return match === null || match === void 0 ? void 0 : match.item.product.name;
            }).join()
        });
    };
    var handleSearch = function(searchString) {
        setSearchTerm(searchString);
    };
    var findMatches = function(searchString) {
        var newMatches = searchString.length > 1 ? dist/* sdkUtils.findFuzzyMenuMatches */.fH.findFuzzyMenuMatches(productDictionary, searchString) : [];
        setMatches(newMatches);
    };
    var triggerModal = function() {
        isMobile && !modalOpen && setModalOpen(true);
    };
    if (status !== "success") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericFocusTrap/* GenericFocusTrap */.G, {
        active: modalOpen,
        focusTrapOptions: {
            clickOutsideDeactivates: true
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMenuSearchContainer, {
            modalOpen: modalOpen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMenuSearchContainerHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMenuSearchInputContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(searchInput/* StyledSearchInput */.GB, {
                                    onChange: function(e) {
                                        triggerModal();
                                        handleSearch(e.target.value);
                                    },
                                    onClick: function() {
                                        return triggerModal();
                                    },
                                    placeholder: (0,stringHelpers/* safelyGetString */.bc)(strings, "store.search_placeholder"),
                                    value: searchTerm
                                }),
                                searchTerm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClearSearch, {
                                    onClick: function() {
                                        return handleSearch("");
                                    },
                                    "aria-label": "Clear Search",
                                    isVisible: searchTerm,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(X/* FilledXSvg */.W, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMagnifyingGlass, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnifyingGlassSvg, {
                                        size: 17
                                    })
                                })
                            ]
                        }),
                        modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCancelButton, {
                            onClick: function() {
                                handleSearch("");
                                setModalOpen(false);
                            },
                            buttonTheme: "knockout",
                            minWidth: 0,
                            children: "Cancel"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HideOnScroll, {
                    disabled: modalOpen,
                    style: {
                        zIndex: constants_styles/* ORDER.MENU_SEARCH_RESULTS */.kl.MENU_SEARCH_RESULTS
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            matches.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchResults, {
                                children: matches.map(function(match) {
                                    var productImage = (0,imageHelper/* getProductImageSrc */.Wr)(match.item.product, {
                                        height: 50
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSearchResult, {
                                            onClick: function() {
                                                handleSearch("");
                                                setModalOpen(false);
                                                onSelect(match.item.product, match.item.category);
                                            },
                                            children: [
                                                productImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchResultImage, {
                                                    backgroundImage: productImage
                                                }),
                                                match.item.product.name
                                            ]
                                        })
                                    }, match.item.product.id);
                                })
                            }),
                            searchTerm.length > 1 && matches.length === 0 && !isTyping && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchResults, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNoResults, {
                                    "aria-live": "polite",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "store.search_no_results_header",
                                            tag: "h2",
                                            dataObj: {
                                                searchTerm: searchTerm
                                            },
                                            disableDataObjEncode: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                            accessor: "store.search_no_results_subheader",
                                            tag: "p"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
// EXTERNAL MODULE: ./src/components/uielements/render.tsx
var render = __webpack_require__(45190);
// EXTERNAL MODULE: ./src/constants/cssClassNames.ts
var cssClassNames = __webpack_require__(5733);
// EXTERNAL MODULE: ./src/constants/features.ts
var features = __webpack_require__(51710);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(20360);
;// CONCATENATED MODULE: ./src/components/ui/observer/observer.tsx



function Observer(param) {
    var children = param.children, onElementView = param.onElementView, _threshold = param.threshold, threshold = _threshold === void 0 ? 0.5 : _threshold, _triggerOnce = param.triggerOnce, triggerOnce = _triggerOnce === void 0 ? false : _triggerOnce;
    var ref = (0,react_intersection_observer/* useInView */.YD)({
        threshold: threshold,
        triggerOnce: triggerOnce
    }), ref1 = ref.ref, inView = ref.inView;
    (0,react.useEffect)(function() {
        if (inView) {
            onElementView();
        }
    // adding onElementView will create an infinite loop,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref1,
        children: children
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/components/allergens/menuCard/index.tsx
var menuCard = __webpack_require__(15185);
// EXTERNAL MODULE: ./src/components/image/index.tsx
var components_image = __webpack_require__(79743);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 5 modules
var ui = __webpack_require__(49586);
;// CONCATENATED MODULE: ./src/components/ui/card/index.tsx





var Details = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8004ded9-0"
})({
    display: "flex",
    flexDirection: "column",
    flex: 1
});
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8004ded9-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.menu_product_card.font)), {
        margin: ".25rem 0 0",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": "3",
        overflow: "hidden",
        "@media (min-width: 768px)": {
            display: "block"
        },
        p: {
            margin: 0
        }
    });
});
var Footer = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-8004ded9-2"
})({
    margin: "auto 0 0",
    padding: "1.5rem 0 0"
});
var ref;
var Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8004ded9-3"
})(function(param) {
    var theme = param.theme;
    return {
        aspectRatio: "1 / 1",
        borderRadius: (ref = theme.global.border_radius * 0.5) !== null && ref !== void 0 ? ref : 0,
        maxWidth: "100%",
        overflow: "hidden",
        position: "relative",
        img: {
            objectFit: "cover",
            display: "block"
        }
    };
});
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-8004ded9-4"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.menu_product_card.secondary_font, {
        line_height: function(value) {
            if (value === "revert") {
                return "145%";
            }
            return value;
        }
    })), {
        margin: 0
    });
});
var card_border_color, _border_radius;
var Horizontal = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-8004ded9-5"
})(function(param) {
    var theme = param.theme, _hasImage = param.hasImage, hasImage = _hasImage === void 0 ? false : _hasImage;
    var _obj;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        border: "1px solid",
        borderColor: (card_border_color = theme.menu_product_card.border_color) !== null && card_border_color !== void 0 ? card_border_color : "transparent",
        borderRadius: (_border_radius = theme.menu_product_card.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0,
        display: "grid",
        gridTemplateColumns: hasImage ? "1fr 5.625rem" : "1fr",
        gap: "1rem",
        padding: ".875rem 1rem"
    }, (0,utils/* getFontStyles */.l)(theme.menu_product_card.font, {
        line_height: function(value) {
            if (value === "revert") {
                return "145%";
            }
            return value;
        }
    })), (_obj = {
        "@media (min-width: 1024px)": {
            gridTemplateColumns: hasImage ? "1fr 9.25rem" : "1fr"
        }
    }, (0,_define_property/* default */.Z)(_obj, "& ".concat(Image), {
        gridColumn: "2"
    }), (0,_define_property/* default */.Z)(_obj, "& ".concat(Details), {
        gridColumn: "1",
        gridRow: "1"
    }), _obj));
});
var _border_color1, _border_radius1;
var Vertical = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-8004ded9-6"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        border: "1px solid",
        borderColor: (_border_color1 = theme.menu_product_card.border_color) !== null && _border_color1 !== void 0 ? _border_color1 : "transparent",
        borderRadius: (_border_radius1 = theme.menu_product_card.border_radius) !== null && _border_radius1 !== void 0 ? _border_radius1 : 0,
        display: "flex",
        flexDirection: "column",
        padding: ".75rem"
    }, (0,utils/* getFontStyles */.l)(theme.menu_product_card.font, {
        line_height: function(value) {
            if (value === "revert") {
                return "145%";
            }
            return value;
        }
    })), (0,_define_property/* default */.Z)({
        "@media (min-width: 768px)": {
            padding: ".875rem 1rem"
        }
    }, "& ".concat(Image, " + ").concat(Details), {
        marginTop: "1rem"
    }));
});
var Card = {
    Details: Details,
    Description: Description,
    Footer: Footer,
    Horizontal: Horizontal,
    Image: Image,
    Title: Title,
    Vertical: Vertical
};

;// CONCATENATED MODULE: ./src/features/menu/tag.tsx


function Tag(param) {
    var value = param.value;
    if (!value) {
        return null;
    }
    var _background_color, _text_color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        backgroundColor: (_background_color = value.background_color) !== null && _background_color !== void 0 ? _background_color : "inherit",
        textColor: (_text_color = value.text_color) !== null && _text_color !== void 0 ? _text_color : "inherit",
        children: [
            value.icon_image_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                src: value.icon_image_url,
                alt: "".concat(value.label, " Tag Icon")
            }),
            !value.hide_label ? value.label : ""
        ]
    });
}
var Container = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e7eea7ff-0"
})(function(param) {
    var backgroundColor = param.backgroundColor, textColor = param.textColor;
    return {
        alignItems: "center",
        background: backgroundColor,
        borderRadius: "0px var(--size-1) var(--size-1) 0px",
        color: textColor,
        display: "flex",
        fontSize: ".625rem",
        justifyContent: "center",
        left: 0,
        padding: "var(--size-1) var(--size-2)",
        position: "absolute",
        top: "var(--size-2)"
    };
});
var Icon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-e7eea7ff-1"
})({
    maxHeight: "1.25rem",
    marginRight: "var(--size-1)"
});

// EXTERNAL MODULE: ./src/redux/commerce/actions.ts
var commerce_actions = __webpack_require__(57588);
// EXTERNAL MODULE: ./src/utils/focusReturn.ts
var focusReturn = __webpack_require__(27658);
;// CONCATENATED MODULE: ./src/features/menu/card.tsx





















function MenuCard(param) {
    var location = param.location, product = param.product, onClick = param.onClick, _showImage = param.showImage, showImage = _showImage === void 0 ? true : _showImage, index = param.index, categoryName = param.categoryName;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), impressionAdded = ref2[0], setImpressionAdded = ref2[1];
    var logo = (0,cmsConfig/* useConfigOverride */.$E)("header").logo;
    var dietary_preferences_enabled = (0,cmsConfig/* useConfigOverride */.$E)("menu").dietary_preferences_enabled;
    var ref3 = (0,cmsConfig/* useConfigOverride */.$E)("menu_product_card"), hide_calories = ref3.hide_calories, hide_price = ref3.hide_price, card_orientation = ref3.card_orientation, hide_description = ref3.hide_description, hide_description_mobile = ref3.hide_description_mobile;
    var label = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization.organization;
    }).label;
    var image = (0,imageHelper/* getProductImageSrc */.Wr)(product, {
        height: 500
    });
    var ref4;
    var formattedPrice = (0,menu/* formatDisplayPriceByCountry */.bL)(product.pretty_price, (ref4 = location === null || location === void 0 ? void 0 : location.country) !== null && ref4 !== void 0 ? ref4 : "US");
    var dispatch = (0,redux/* useDispatch */.I0)();
    var ref5;
    var details = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: showImage && Boolean(image),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Image, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                            src: image,
                            alt: "Product image",
                            layout: "fill"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                            value: (ref5 = (ref = product.marketing_tags) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref5 !== void 0 ? ref5 : null
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: showImage && card_orientation !== "horizontal" && !Boolean(image),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Image, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderImage, {
                        children: logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                            src: logo,
                            alt: label,
                            height: 32,
                            width: 160,
                            objectFit: "contain"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            children: label
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Details, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Title, {
                        children: product.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                        condition: Boolean(product.description) && !hide_description,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileRender, {
                            shouldHide: hide_description_mobile,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Description, {
                                children: (ref1 = product.description) === null || ref1 === void 0 ? void 0 : ref1.split("\n").map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: item.trim()
                                    }, "line-".concat(index));
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                        condition: !hide_price && Boolean(formattedPrice) || !hide_calories && Boolean(product.pretty_calories),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card.Footer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                                    gap: "$3",
                                    children: [
                                        !hide_price && formattedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                                            children: formattedPrice
                                        }),
                                        !hide_calories && /*#__PURE__*/ (0,jsx_runtime.jsx)(Attribute, {
                                            children: product.pretty_calories
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                    condition: dietary_preferences_enabled,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menuCard/* Allergens */.L, {
                                        productAllergens: product,
                                        compileAllergensMethod: menu/* getAllProductOptionAllergens */.XH,
                                        mode: global/* ALLERGEN_CARD_MODE.MENU */.JT.MENU
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_Button, {
        onClick: function() {
            (0,focusReturn/* storeFocusedElement */.cS)();
            onClick();
        },
        animateOnPointer: showImage && Boolean(image),
        role: "group",
        "aria-label": "Product: ".concat(product.name).concat(formattedPrice ? ", ".concat(formattedPrice) : ""),
        "data-testid": "menu-product-card",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Observer, {
                threshold: 0.01,
                onElementView: function onElementView() {
                    if (!impressionAdded) {
                        dispatch(commerce_actions/* default.commerceItemImpression */.Z.commerceItemImpression(product, categoryName, index));
                        setImpressionAdded(true);
                    }
                }
            }),
            card_orientation === "vertical" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Vertical, {
                children: details
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Horizontal, {
                hasImage: showImage && Boolean(image),
                children: details
            })
        ]
    });
}
var card_background_color, menu_card_border_color, card_border_radius;
var card_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-1c303ac9-0"
})(function(param) {
    var theme = param.theme, _animateOnPointer = param.animateOnPointer, animateOnPointer = _animateOnPointer === void 0 ? true : _animateOnPointer;
    var _obj;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        all: "unset",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        outline: "revert",
        backgroundColor: (card_background_color = theme.menu_product_card.background_color) !== null && card_background_color !== void 0 ? card_background_color : "transparent",
        border: "1px solid ".concat((menu_card_border_color = theme.menu_product_card.border_color) !== null && menu_card_border_color !== void 0 ? menu_card_border_color : "transparent"),
        borderRadius: "".concat((card_border_radius = theme.menu_product_card.border_radius) !== null && card_border_radius !== void 0 ? card_border_radius : 0, "px")
    }, (0,utils/* getFontStyles */.l)(theme.menu_product_card.font, {
        line_height: function(value) {
            if (value === "revert") {
                return "145%";
            }
            return value;
        }
    })), (_obj = {}, (0,_define_property/* default */.Z)(_obj, "& ".concat(Card.Vertical, ", & ").concat(Card.Horizontal), {
        height: "100%",
        transition: "all .4s ease"
    }), (0,_define_property/* default */.Z)(_obj, "& ".concat(Card.Image, " img"), {
        transition: "all .4s ease"
    }), (0,_define_property/* default */.Z)(_obj, "&:hover ".concat(Card.Image, " img"), {
        transform: animateOnPointer ? "scale(1.1)" : "none"
    }), (0,_define_property/* default */.Z)(_obj, "&:hover ".concat(Card.Vertical, ", &:hover ").concat(Card.Horizontal), {
        borderColor: theme.global.primary_active_color
    }), _obj));
});
var Attribute = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1c303ac9-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.menu_product_card.font, {
        font_size: function(value) {
            if (typeof value === "number") {
                return value * 0.875;
            }
            return value;
        }
    }));
});
var Price = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1c303ac9-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontWeight: 700
    }, (0,utils/* getFontStyles */.l)(theme.menu_product_card.font, [
        "color",
        "font_family",
        "font_size",
        "font_style",
        "line_height"
    ], {
        font_size: function(value) {
            if (typeof value === "number") {
                return value * 0.875;
            }
            return value;
        }
    }));
});
var PlaceholderImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c303ac9-3"
})({
    alignItems: "center",
    backgroundColor: "#e4e4e4",
    display: "flex",
    justifyContent: "center",
    height: "100%",
    padding: "1rem",
    width: "100%",
    img: {
        filter: "grayscale(1)",
        height: "2rem",
        opacity: 0.2,
        width: "10rem"
    }
});
var Text = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1c303ac9-4"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        fontWeight: "bold",
        opacity: 0.2
    }, (0,utils/* getFontStyles */.l)(theme.header.font, [
        "font_family",
        "font_size"
    ]));
});
var MobileRender = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c303ac9-5"
})(function(param) {
    var shouldHide = param.shouldHide;
    return {
        display: shouldHide ? "none" : "block",
        "@media (min-width: 640px)": {
            display: "block"
        }
    };
});

// EXTERNAL MODULE: ./src/redux/menu/actions.ts
var menu_actions = __webpack_require__(22354);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
;// CONCATENATED MODULE: ./src/utils/useThrottledListener.ts


/**
  * Provides an abstraction to create throttled events in a react style way
  *
  * The following will create a throttled event that fires every 1000ms a performs
  * some action that should happen. An optional "refreshToken" boolean can sent
  * to restart the memoized throttle.
  *
  * ```
  * const { ref, listener } = useThrottledListener(
    () => {
      // do something
    },
    1000,
    refreshToken,
   );
  * ```
  * @param shouldRefresh
  * @param duration
  * @returns ThrottledListener
  */ var useThrottledListener = function(callback, duration) {
    var shouldRefresh = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref = (0,react.useRef)(null);
    var listener = (0,react.useCallback)((0,lodash.throttle)(callback, duration), [
        shouldRefresh
    ]);
    return {
        ref: ref,
        listener: listener
    };
};

;// CONCATENATED MODULE: ./src/utils/accessibility.ts
/**
 * Accessibility utilities for scroll and focus management
 */ /**
 * Scrolls to an element and sets focus for keyboard navigation
 * Uses modern scrollend event when available, falls back to immediate focus
 */ var scrollToAndFocus = function(targetId) {
    var scrollOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        behavior: "smooth",
        block: "start"
    };
    var element = document.getElementById(targetId);
    if (!element) return;
    // For instant scrolling, focus immediately
    if (scrollOptions.behavior !== "smooth") {
        element.scrollIntoView(scrollOptions);
        element.focus();
        return;
    }
    // Use modern scrollend event if available
    if ("onscrollend" in window) {
        var handleScrollEnd = function() {
            element.focus();
            window.removeEventListener("scrollend", handleScrollEnd);
        };
        window.addEventListener("scrollend", handleScrollEnd);
        element.scrollIntoView(scrollOptions);
        return;
    }
    // Fallback: focus immediately for older browsers
    element.scrollIntoView(scrollOptions);
    element.focus();
};
/**
 * Scrolls to an element with offset and sets focus
 * Used for precise positioning with fixed headers
 */ var scrollToElementWithOffset = function(element) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, behavior = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "smooth";
    if (!element) return;
    var targetPosition = window.scrollY + element.getBoundingClientRect().top - offset;
    window.scrollTo({
        top: targetPosition,
        behavior: behavior
    });
    // Handle focus based on scroll behavior
    if (behavior === "smooth" && "onscrollend" in window) {
        var handleScrollEnd = function() {
            element.focus();
            window.removeEventListener("scrollend", handleScrollEnd);
        };
        window.addEventListener("scrollend", handleScrollEnd);
    } else {
        element.focus();
    }
};
/**
 * Makes an element focusable and generates consistent category IDs
 */ var makeFocusable = function(element) {
    var tabIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
    if (!element.hasAttribute("tabindex")) {
        element.setAttribute("tabindex", tabIndex.toString());
    }
};
var generateCategoryId = function(categoryId) {
    return "category-".concat(categoryId);
};

;// CONCATENATED MODULE: ./src/features/menu/categories.tsx

















var MenuCategories = function(param) {
    var categories = param.categories, customizeProduct = param.customizeProduct, currentCategory = param.currentCategory, activeTagIds = param.activeTagIds;
    var updateActiveCategory = function updateActiveCategory() {
        if (!containers.current) {
            return;
        }
        var id = "";
        containers.current.forEach(function(container) {
            var bounds = container.element.getBoundingClientRect();
            // since we go top down, we just need to grab the last category that matches our filter
            // we have to use a slightly higher threshold here to avoid direct category clicks highlighting
            // the previous category
            if (bounds.top <= 250) {
                id = container.id;
            }
        });
        dispatch(menu_actions/* default.pushNavigationStatus */.Z.pushNavigationStatus(id));
    };
    // we need to check multiple elements, so we have an array'd ref
    // instead of a one-off ref element.
    var containers = (0,react.useRef)([]);
    var detail = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.locations;
    }).detail;
    var requestedNavigationUpdate = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.menu;
    }).requestedNavigationUpdate;
    var category_nav_display = (0,cmsConfig/* useConfigOverride */.$E)("menu_categories").category_nav_display;
    var mobile_web_product_grid = (0,cmsConfig/* useConfigOverride */.$E)("menu").mobile_web_product_grid;
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("menu_product_card"), card_orientation = ref.card_orientation, hide_image = ref.hide_image;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var additionalOffset = category_nav_display === CATEGORY_NAV_DISPLAY.STICKY || category_nav_display === CATEGORY_NAV_DISPLAY.LEFT ? 192 : 0;
    (0,react.useEffect)(function() {
        if (!containers.current) {
            return;
        }
        var category = containers.current.find(function(container) {
            return container.id === currentCategory;
        });
        if (category) {
            // Use the new utility function for proper scroll and focus management
            scrollToElementWithOffset(category.element, additionalOffset, "auto");
        } else {
            // immediately highlight the first category in the navigation bar
            updateActiveCategory();
        }
    }, []);
    (0,react.useEffect)(function() {
        if (!containers.current) {
            return;
        }
        var category = containers.current.find(function(container) {
            return container.id === requestedNavigationUpdate;
        });
        if (category) {
            // Use the new utility function for proper scroll and focus management
            scrollToElementWithOffset(category.element, additionalOffset, "smooth");
        }
        dispatch(menu_actions/* default.requestNavigationUpdate */.Z.requestNavigationUpdate(""));
    }, [
        additionalOffset,
        dispatch,
        requestedNavigationUpdate
    ]);
    // a memoized, throttled scroll listener we can pass to the window
    // this will ensure that we aren't peforming complex updates on every scroll event
    var listener = useThrottledListener(updateActiveCategory, 200).listener;
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", listener);
        return function() {
            return window.removeEventListener("scroll", listener);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: categories.filter(function(category) {
            return category.products.length > 0;
        }).filter(function(category) {
            return (0,menu/* filterCategoriesByTagId */.$9)(category, activeTagIds);
        }).map(function(category) {
            var ref;
            var parsedCategoryDescription = (ref = category.description) === null || ref === void 0 ? void 0 : ref.split("\n");
            var hasImage = false;
            if (!hide_image) {
                hasImage = category.products.some(function(product) {
                    var ref;
                    return product.image || ((ref = product.images) === null || ref === void 0 ? void 0 : ref.image_url_1_by_1) ? true : false;
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: generateCategoryId(category.id),
                ref: function(el) {
                    // we can control how our ref is inserted
                    // which is necessary if we want to use an array'd ref
                    if (el) {
                        var id = String(category.id);
                        containers.current = containers.current// we can have a situation where duplicate categories exist after
                        // navigating between food halls. A simple fix is to filter out the existing item
                        // this makes sense because we want the new, correct element existing on screen
                        .filter(function(item) {
                            return item.id !== id;
                        }).concat({
                            element: el,
                            id: id
                        });
                        // Make the category section focusable for accessibility
                        makeFocusable(el);
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(categories_Container, {
                    "data-menu-category-id": category.global_id,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader, {
                            className: "koala__ui-menu-category-heading",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Observer, {
                                triggerOnce: true,
                                onElementView: function() {
                                    return dispatch(commerce_actions/* default.commerceCategoryView */.Z.commerceCategoryView(category, detail));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        id: dist/* sdkUtils.slugName */.fH.slugName(category),
                                        children: category.name
                                    }),
                                    parsedCategoryDescription === null || parsedCategoryDescription === void 0 ? void 0 : parsedCategoryDescription.map(function(line, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: line.trim()
                                        }, "line-".concat(index));
                                    })
                                ]
                            }, category.id)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                            cardOrientation: card_orientation,
                            mobileGridCount: mobile_web_product_grid,
                            children: category.products.filter(function(product) {
                                return (0,menu/* filterProductsByTagId */.Aj)(product.filter_tags, activeTagIds);
                            }).map(function(product, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuCard, {
                                    onClick: function() {
                                        dispatch(commerce_actions/* default.commerceItemClick */.Z.commerceItemClick(product, category.name, index));
                                        customizeProduct(product, category);
                                    },
                                    categoryName: category.name,
                                    location: detail,
                                    product: product,
                                    showImage: hasImage,
                                    index: index
                                }, product.id);
                            })
                        })
                    ]
                })
            }, category.id);
        })
    });
};
var categories_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-212a839e-0"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexWrap: theme.menu_categories.category_menu_header_display === CATEGORY_MENU_HEADER_DISPLAY.STACKED || theme.menu_categories.category_menu_header_display === CATEGORY_NAV_DISPLAY.LEFT ? "wrap" : "nowrap",
        "@media screen and (max-width: 1024px)": {
            display: "block"
        }
    };
});
var CategoryHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-212a839e-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        display: "block",
        marginBottom: "20px"
    }, theme.menu_categories.category_menu_header_display === "stacked" && {
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "655px",
        textAlign: "center",
        width: "100%"
    }, theme.menu_categories.category_menu_header_display === "column" && {
        width: "15%"
    }, theme.menu_categories.category_nav_display === "left" && theme.menu_categories.category_menu_header_display !== "stacked" && {
        width: "100%",
        marginLeft: "20px"
    }), {
        h2: (0,_object_spread/* default */.Z)({
            margin: 0,
            wordWrap: "break-word"
        }, (0,utils/* getFontStyles */.l)(theme.menu_category_header.font, [
            "color",
            "font_family",
            "font_size", 
        ])),
        p: (0,_object_spread/* default */.Z)({
            margin: "10px 0 0"
        }, (0,utils/* getFontStyles */.l)(theme.menu_category_header.secondary_font, [
            "color",
            "font_family",
            "font_size", 
        ])),
        "@media (max-width: 1024px)": {
            margin: "0 auto var(--size-5)",
            width: "100%",
            "h2, p": {
                textAlign: "center"
            }
        }
    });
});
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-212a839e-2"
})(function(param) {
    var cardOrientation = param.cardOrientation, mobileGridCount = param.mobileGridCount;
    return {
        display: "grid",
        gridTemplateColumns: cardOrientation === "vertical" && mobileGridCount === "2x" ? "1fr 1fr" : "1fr",
        gap: "1rem",
        width: "100%",
        "@media screen and (min-width: 768px)": {
            gap: "1.5rem",
            gridTemplateColumns: cardOrientation === "vertical" ? "repeat(auto-fill, minmax(12rem, 1fr))" : "repeat(auto-fill, minmax(18rem, 1fr))"
        },
        "@media screen and (min-width: 1024px)": {
            gap: "1.5rem",
            gridTemplateColumns: cardOrientation === "vertical" ? "repeat(auto-fill, minmax(14rem, 1fr))" : "repeat(auto-fill, minmax(24rem, 1fr))"
        }
    };
});

// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
// EXTERNAL MODULE: ./src/features/configs/organization.ts
var organization = __webpack_require__(5981);
;// CONCATENATED MODULE: ./src/features/menu/empty.tsx








function EmptyMenu() {
    var ref = (0,organization/* useOrganization */.o)(), organizationConfig = ref.data, isLoading = ref.isLoading;
    var isSingleLocation = organizationConfig === null || organizationConfig === void 0 ? void 0 : organizationConfig.locations.features.isSingleLocation;
    var isSingleLocationEnabled = Boolean((isSingleLocation === null || isSingleLocation === void 0 ? void 0 : isSingleLocation.enabled) && isSingleLocation.storeLocationId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
        direction: "vertical",
        gap: "$4",
        css: {
            padding: "$14"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                children: "Online ordering is not currently available."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                children: "While we’re unavailable right now, you can still place an order for the future. Please use the module above to schedule your order"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: !isSingleLocationEnabled && !isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primaryButton_styles/* StyledPrimaryButton */.D, {
                        as: "a",
                        children: "Find a location"
                    })
                })
            })
        ]
    });
}
var Heading = (0,stitches/* styled */.zo)("h2", {
    fontSize: "$text400",
    fontWeight: "bold",
    textAlign: "center",
    margin: 0
});
var Paragraph = (0,stitches/* styled */.zo)("p", {
    fontSize: "$text200",
    textAlign: "center",
    margin: 0
});

;// CONCATENATED MODULE: ./src/features/store/disclaimers.tsx

function disclaimers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: var(--size-4xl);\n"
    ]);
    disclaimers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Disclaimers() {
    var ref;
    var locations = (0,redux/* useSelector */.v9)(function(state) {
        return state.app;
    }).locations;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclaimers_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                tag: "p",
                accessor: "store.menu_disclaimer",
                html: true,
                dataObj: locations.detail
            }),
            (ref = locations.detail) === null || ref === void 0 ? void 0 : ref.disclaimers.map(function(disclaimer, index) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(disclaimers_Text, {
                    dangerouslySetInnerHTML: {
                        __html: (ref = disclaimer.description) === null || ref === void 0 ? void 0 : ref.replace(/(?:\r\n|\r|\n)/g, "<br /><br />")
                    }
                }, "".concat(disclaimer.name, "-").concat(index));
            })
        ]
    });
}
var disclaimers_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8dd99da-0"
})(disclaimers_templateObject());
var disclaimers_Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-f8dd99da-1"
})({
    overflowWrap: "break-word",
    wordBreak: "break-all"
});

// EXTERNAL MODULE: ./src/utils/config.ts
var config = __webpack_require__(19257);
;// CONCATENATED MODULE: ./src/features/store/navigation/components/list.tsx













function List(param) {
    var categories = param.categories, locationDetail = param.locationDetail, activeTagIds = param.activeTagIds, context = param.context;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var navigationStatus = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.menu;
    }).navigationStatus;
    var webConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }).webConfig;
    var useBrandId = (0,config/* supportsBrandId */.i)(webConfig);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: categories.map(function(category, index) {
            var url = (0,menu/* updateStoreMenuUrl */.PS)({
                // @ts-expect-error id can't be undefined, which is a valid value for `locationDetail.brand_id`
                id: useBrandId ? locationDetail.brand_id : locationDetail.id,
                name: locationDetail.label,
                catId: String(category.id),
                catName: category.name
            }, activeTagIds);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(url, "#").concat(generateCategoryId(category.id)),
                replace: true,
                shallow: true,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuNavLink, {
                    "data-testid": "menu-navigation-category",
                    id: (0,menu/* deriveCategoryNavId */.UP)(String(category.global_id), context),
                    active: navigationStatus ? String(category.id) === navigationStatus : index === 0,
                    onClick: function(event) {
                        event.preventDefault();
                        (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.browse */.m1.browse, googleAnalytics/* gaActions.clickCategory */.cE.clickCategory, {
                            label: category.name
                        });
                        dispatch(menu_actions/* default.requestNavigationUpdate */.Z.requestNavigationUpdate(String(category.id)));
                        // Handle focus management for accessibility
                        scrollToAndFocus(generateCategoryId(category.id));
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: category.name
                    })
                })
            }, "".concat(dist/* sdkUtils.slugName */.fH.slugName(category), "-").concat(index));
        })
    });
}
var StyledMenuNavLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-feeb5869-0"
})(function(param) {
    var theme = param.theme, _active = param.active, active = _active === void 0 ? false : _active;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        borderBottom: "3px solid transparent",
        borderTop: "3px solid transparent",
        cursor: "pointer",
        opacity: active ? 1 : 0.6,
        padding: "5px 10px 5px 0",
        textAlign: [
            "left",
            "column"
        ].includes(theme.menu_categories.category_nav_display) ? "left" : "center",
        transition: "all 0.2s linear"
    }, (0,utils/* getFontStyles */.l)(theme.menu_categories.category_nav_font, {
        color: function(value) {
            if (active) {
                return theme.menu_categories.category_nav_text_hover_color;
            }
            return value;
        }
    })), {
        borderBottomColor: active ? theme.menu_categories.category_nav_text_hover_color : "transparent",
        "&:hover": {
            borderBottomColor: theme.menu_categories.category_nav_text_hover_color,
            color: theme.menu_categories.category_nav_text_hover_color,
            opacity: 1,
            textDecoration: "none"
        }
    });
});

;// CONCATENATED MODULE: ./src/features/store/navigation/desktop.tsx








function Desktop(param) {
    var categories = param.categories, locationDetail = param.locationDetail, activeTagIds = param.activeTagIds;
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("menu_categories"), category_nav_background_color = ref.category_nav_background_color, category_nav_display = ref.category_nav_display, category_nav_text_color = ref.category_nav_text_color;
    var regular = (0,cmsConfig/* useConfigOverride */.$E)("secondary_font").regular;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_Container, {
        "data-testid": "menu-navigation",
        css: {
            backgroundColor: category_nav_background_color
        },
        layout: category_nav_display,
        "data-css-override": "StyledDesktopNavLayout",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
            layout: category_nav_display,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                    condition: category_nav_display === CATEGORY_NAV_DISPLAY.COLUMN,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_Title, {
                        "data-css-override": "StyledMenuTitle",
                        css: {
                            "& h1": {
                                color: category_nav_text_color,
                                fontFamily: regular.font_family
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Menu"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                    role: "navigation",
                    "aria-label": "Main Desktop Navigation",
                    layout: category_nav_display,
                    className: cssClassNames/* CSS_CLASSES.STORE_MENU.DESKTOP_NAV */.Y.STORE_MENU.DESKTOP_NAV,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                        activeTagIds: activeTagIds,
                        locationDetail: locationDetail,
                        categories: categories,
                        context: "desktop"
                    })
                })
            ]
        })
    });
}
var desktop_Container = (0,stitches/* styled */.zo)("div", {
    display: "none",
    zIndex: 9,
    variants: {
        layout: {
            sticky: {
                position: "sticky",
                top: "8.5rem",
                "@xl": {
                    top: "$20"
                }
            },
            inline: {},
            column: {},
            left: {}
        }
    },
    "@md": {
        display: "block"
    }
});
var Content = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    margin: "0 auto",
    maxWidth: "1440px",
    height: "$20",
    padding: "0 $5",
    width: "100%",
    variants: {
        layout: {
            sticky: {},
            inline: {},
            column: {
                height: "auto",
                padding: "$5",
                "& > div": {
                    flexBasis: "20%",
                    flexGrow: "initial"
                }
            },
            left: {
                padding: 0
            }
        }
    }
});
var desktop_Title = (0,stitches/* styled */.zo)("div", {
    "& h1": {
        fontSize: "2rem",
        margin: "$5 0"
    }
});
var _obj;
var Navigation = (0,stitches/* styled */.zo)("nav", (_obj = {
    display: "flex",
    flexBasis: "100%",
    flexDirection: "row",
    flexWrap: "inherit",
    justifyContent: "space-between"
}, (0,_define_property/* default */.Z)(_obj, StyledMenuNavLink, {
    alignItems: "center",
    display: "flex",
    padding: "0 $3"
}), (0,_define_property/* default */.Z)(_obj, "variants", {
    layout: {
        sticky: {},
        inline: {},
        column: // @TODO: verify these settings and migrate them to the button itself
        (0,_define_property/* default */.Z)({
            flexBasis: "60%",
            flexWrap: "wrap",
            justifyContent: "flex-start"
        }, "& ".concat(StyledMenuNavLink), (0,_define_property/* default */.Z)({
            width: "33.33%"
        }, "&:hover, &.".concat(cssClassNames/* CSS_CLASSES.STORE_MENU.ACTIVE_NAV_BUTTON */.Y.STORE_MENU.ACTIVE_NAV_BUTTON), {
            borderColor: "transparent",
            textDecoration: "underline"
        })),
        left: (0,_define_property/* default */.Z)({
            flexDirection: "column",
            padding: "$5",
            height: "calc(100vh - 100px)",
            justifyContent: "flex-start",
            overflowY: "scroll"
        }, "& ".concat(StyledMenuNavLink), {
            display: "block",
            padding: "$5"
        })
    }
}), _obj));

;// CONCATENATED MODULE: ./src/features/store/navigation/components/dropdown.tsx





function DropDown(param) {
    var categories = param.categories;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var navigationStatus = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.menu.navigationStatus;
    });
    /*
    Dropdown List
    - Accounting for category exclusions
    - Accounting for categories filtered by active tag
  */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
        title: "Choose a category",
        value: navigationStatus,
        onChange: function(e) {
            var selectedCategory = categories.find(function(category) {
                return String(category.id) === e.target.value;
            });
            if (!selectedCategory) {
                return;
            }
            dispatch(menu_actions/* default.requestNavigationUpdate */.Z.requestNavigationUpdate(String(selectedCategory.id)));
            (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.browse */.m1.browse, googleAnalytics/* gaActions.clickCategory */.cE.clickCategory, {
                label: "Mobile: ".concat(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name)
            });
        },
        children: categories.map(function(category, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: String(category.id),
                children: category.name
            }, "".concat(dist/* sdkUtils.slugName */.fH.slugName(category), "-").concat(index));
        })
    });
}

// EXTERNAL MODULE: ./src/components/uielements/chevron/index.tsx
var chevron = __webpack_require__(27252);
;// CONCATENATED MODULE: ./src/features/store/navigation/mobile.tsx
















function Mobile(param) {
    var activeTagIds = param.activeTagIds, categories = param.categories, locationDetail = param.locationDetail;
    var navigationStatus = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.menu.navigationStatus;
    });
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("menu_categories"), mobile_category_nav_display = ref.mobile_category_nav_display, category_nav_background_color = ref.category_nav_background_color, category_nav_text_color = ref.category_nav_text_color;
    /** @FIXME font refactor. */ var bold = (0,cmsConfig/* useConfigOverride */.$E)("primary_font").bold;
    var ref1 = (0,cmsConfig/* useConfigOverride */.$E)("forms"), background_color = ref1.background_color, border_color = ref1.border_color, border_radius = ref1.border_radius, font = ref1.font;
    var listRef = (0,react.useRef)(null);
    var listContext = "mobile";
    // Scroll active menu categories into view
    (0,react.useEffect)(function() {
        var activeElement = document.getElementById((0,menu/* deriveCategoryNavId */.UP)(navigationStatus, listContext));
        if (listRef.current) {
            listRef.current.scrollTo({
                left: (0,utils_global/* getElementOffset */.pW)(activeElement).left,
                behavior: "smooth"
            });
        }
    }, [
        navigationStatus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(mobile_Container, {
        "data-testid": "menu-navigation",
        css: {
            backgroundColor: category_nav_background_color
        },
        className: cssClassNames/* CSS_CLASSES.STORE_MENU.MOBILE_NAV */.Y.STORE_MENU.MOBILE_NAV,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: mobile_category_nav_display === MOBILE_CATEGORY_NAV_DISPLAY.DROPDOWN,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                    css: {
                        "& select": (0,_object_spread/* default */.Z)({
                            backgroundColor: background_color,
                            border: "1px solid ".concat(border_color),
                            borderRadius: "".concat(border_radius, "px"),
                            fontSize: "1rem"
                        }, (0,utils/* getFontStyles */.l)(font, [
                            "color",
                            "font_family",
                            "font_weight",
                            "line_height", 
                        ]))
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDown, {
                            categories: categories
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron/* ChevronDown */._, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: mobile_category_nav_display === MOBILE_CATEGORY_NAV_DISPLAY.SCROLL,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                    ref: listRef,
                    css: {
                        color: category_nav_text_color,
                        fontFamily: bold.font_family
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                        activeTagIds: activeTagIds,
                        categories: categories,
                        locationDetail: locationDetail,
                        context: "mobile"
                    })
                })
            })
        ]
    });
}
var mobile_Container = (0,stitches/* styled */.zo)("div", {
    display: "block",
    height: "$12",
    position: "sticky",
    top: "6.5rem",
    zIndex: 1,
    "& > div ~ div": {
        paddingTop: 0
    },
    "@md": {
        display: "none"
    }
});
var DropdownWrapper = (0,stitches/* styled */.zo)("div", {
    alignItems: "center",
    display: "flex",
    height: "100%",
    padding: "$1-5",
    position: "relative",
    "& select": {
        appearance: "none",
        display: "block",
        height: "100%",
        padding: "0 $12 0 $4",
        width: "100%"
    }
});
var ListWrapper = (0,stitches/* styled */.zo)("div", (0,_define_property/* default */.Z)({
    transition: "all 0.2s linear",
    alignItems: "center",
    display: "flex",
    height: "100%",
    overflowX: "scroll",
    width: "100%",
    "-webkit-overflow-scrolling": "touch"
}, "& ".concat(StyledMenuNavLink), {
    alignItems: "center",
    display: "flex",
    flexShrink: "0",
    height: "100%",
    padding: "0 $5"
}));
var DropdownIcon = (0,stitches/* styled */.zo)("div", {
    alignItems: "center",
    display: "flex",
    padding: "0 $4",
    pointerEvents: "none",
    position: "absolute",
    right: "$2-5"
});

;// CONCATENATED MODULE: ./src/features/store/navigation/index.tsx






function MenuNavigation(param) {
    var categories = param.categories, locationDetail = param.locationDetail, activeTagIds = param.activeTagIds;
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("admin"), foodHallEnabled = ref.food_hall;
    if (!categories) {
        return null;
    }
    // Filter categories by
    // - Any brand-specific hard-coded exclusions
    // - Tag ID, if one is active
    var filteredCategories = categories.filter(function(category) {
        return category.products.length;
    }).filter(function(category) {
        return (0,menu/* filterCategoriesByTagId */.$9)(category, activeTagIds !== null && activeTagIds !== void 0 ? activeTagIds : []);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: Boolean(!foodHallEnabled || activeTagIds),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop, {
                    categories: filteredCategories,
                    locationDetail: locationDetail,
                    activeTagIds: activeTagIds
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile, {
                categories: filteredCategories,
                locationDetail: locationDetail,
                activeTagIds: activeTagIds
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/features/popular-items/service.tsx
var popular_items_service = __webpack_require__(7987);
// EXTERNAL MODULE: ./src/features/popular-items/widget.tsx + 2 modules
var widget = __webpack_require__(18827);
;// CONCATENATED MODULE: ./src/features/store/popular-items.tsx












function PopularItems(param) {
    var location = param.location, menuCategories = param.menuCategories;
    var ref, ref1;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var time_wanted = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr).time_wanted;
    var ref2;
    var ref3 = (0,popular_items_service/* usePopularItems */.R)({
        location: (ref2 = (ref = location.detail) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : 0,
        wantedAt: time_wanted
    }), title = ref3.title, response = ref3.response, enabled = ref3.enabled, count = ref3.count, getItem = ref3.getItem;
    if (!enabled || response.status !== "success") {
        return null;
    }
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(widget/* Widget */.$, {
        items: (ref4 = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.products.map(getItem)) !== null && ref4 !== void 0 ? ref4 : [],
        count: count,
        onClick: function onClick(item, index) {
            dispatch(commerce_actions/* default.commerceItemClick */.Z.commerceItemClick(item, "popular-item", index));
            dispatch(customize_actions/* default.setProduct */.Z.setProduct({
                product: item,
                menuCategories: menuCategories,
                label: checkout/* PRODUCT_LOCATION_LABELS.MENU */.X.MENU
            }));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popular_items_Title, {
            children: title
        })
    });
}
var popular_items_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-6f05b4f1-0"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.menu_category_header.font)), {
        margin: 0
    });
});

// EXTERNAL MODULE: ./src/redux/global/reducer.ts
var global_reducer = __webpack_require__(83626);
// EXTERNAL MODULE: ./src/redux/locations/actions.ts
var locations_actions = __webpack_require__(17464);
// EXTERNAL MODULE: ./src/services/recommendations.service.ts
var recommendations_service = __webpack_require__(20321);
;// CONCATENATED MODULE: ./src/features/store/details.tsx

function details_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  ",
        "\n\n  @media (max-width: 767px) {\n    display: block;\n  }\n"
    ]);
    details_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















































function StoreDetails(param) {
    var routeParams = param.routeParams;
    var ref, ref1, ref2;
    var ref3 = (0,redux/* useSelector */.v9)(function(state) {
        return state.app;
    }), basket = ref3.basket, locations = ref3.locations;
    var ref4 = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig;
    }), strings = ref4.strings, webConfig = ref4.webConfig;
    var address = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.conveyanceMode;
    }).address;
    var ref5 = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.global;
    }), cartMigration = ref5.cartMigration, fulfillmentModal = ref5.fulfillmentModal;
    var activeTagIds = (0,redux/* useSelector */.v9)(foodHallsSliceSelector).activeTagIds;
    var time_wanted = (0,redux/* useSelector */.v9)(reducer/* selectConveyance */.Fr).time_wanted;
    var dispatch = (0,redux/* useDispatch */.I0)();
    var displayErrorToast = (0,global_reducer/* useGlobalDispatch */.xP)().displayErrorToast;
    var selectedPopularItem = (0,recommendations_service/* getSelectedPopularItem */.U7)();
    var router = (0,next_router.useRouter)();
    var ref6;
    var ref7 = (0,service/* useMenu */.H)({
        id: (ref6 = locations === null || locations === void 0 ? void 0 : (ref = locations.detail) === null || ref === void 0 ? void 0 : ref.id) !== null && ref6 !== void 0 ? ref6 : 0,
        wantedAt: time_wanted
    }), menuCategories = ref7.categories, isLoading = ref7.isLoading;
    (0,react.useEffect)(function() {
        var ref;
        var ref1;
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOG */.AH.LOG, {
            name: constants_events/* LOG_EVENTS.MENU_CSR_FETCHED */.yX.MENU_CSR_FETCHED,
            details: JSON.stringify({
                locationId: (ref1 = locations === null || locations === void 0 ? void 0 : (ref = locations.detail) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : 0,
                time_wanted: time_wanted,
                hasProducts: menuCategories.some(function(category) {
                    return category.products.length > 0;
                })
            })
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locations === null || locations === void 0 ? void 0 : (ref1 = locations.detail) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    var _food_hall;
    var foodHallEnabled = (_food_hall = webConfig.admin.food_hall) !== null && _food_hall !== void 0 ? _food_hall : false;
    var useBrandId = (0,config/* supportsBrandId */.i)(webConfig);
    var hasAvailableProducts = Boolean(menuCategories.some(function(category) {
        return category.products.length > 0;
    }));
    var customizeProduct = function(item, category, urlTrigger) {
        var ref;
        // Don't update the URL if the PDP is already being triggered from the URL
        if (!urlTrigger) {
            var ref1, ref2, ref3;
            var url = (0,menu/* updateStoreMenuUrl */.PS)({
                // @ts-expect-error ensure that locationDetail is defined.
                id: useBrandId ? (ref1 = locations.detail) === null || ref1 === void 0 ? void 0 : ref1.brand_id : (ref2 = locations.detail) === null || ref2 === void 0 ? void 0 : ref2.id,
                name: (ref3 = locations.detail) === null || ref3 === void 0 ? void 0 : ref3.label,
                catId: category.id.toString(),
                catName: category.name,
                productId: item.id,
                productName: item.name
            }, activeTagIds);
            void router.replace(url, undefined, {
                shallow: true
            });
        }
        // If the basket location differs from the current menu location and
        // the current basket contains items, trigger the basket reset modal
        if (basket.location.id !== ((ref = locations.detail) === null || ref === void 0 ? void 0 : ref.id) && basket.content && basket.content.basket_items.length) {
            dispatch(global_actions/* default.setCartMigration */.Z.setCartMigration(constants_locations/* CART_MIGRATION_TYPES.RESET */.Jl.RESET, item));
            return;
        }
        dispatch(customize_actions/* default.setProduct */.Z.setProduct({
            product: item,
            menuCategories: menuCategories,
            label: checkout/* PRODUCT_LOCATION_LABELS.MENU */.X.MENU
        }));
    };
    var verifyFulfillmentAddress = function() {
        var ref, ref1;
        if (cartMigration.type !== null || fulfillmentModal.display) {
            return;
        }
        if (((ref = locations.detail) === null || ref === void 0 ? void 0 : ref.is_delivery_only) && !((ref1 = basket.fulfillment) === null || ref1 === void 0 ? void 0 : ref1.address) && !address) {
            dispatch(global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal(true, locations.detail, dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY, false, // @ts-expect-error differentiate between `null` and `undefined`.
            null, false, true));
        }
    };
    (0,react.useEffect)(function() {
        if (!menuCategories.length || !selectedPopularItem) {
            return;
        }
        var category = undefined;
        var product = undefined;
        menuCategories.forEach(function(categoryItem) {
            categoryItem.products.forEach(function(productItem) {
                if (productItem.id === selectedPopularItem) {
                    category = categoryItem;
                    product = productItem;
                }
            });
        });
        if (product && category) {
            customizeProduct(product, category, true);
        } else {
            dispatch(displayErrorToast("Sorry, the selected item isn't available at this location"));
        }
        // always reset the selected item if we get to this stage
        (0,recommendations_service/* removeSelectedPopularItem */.Sh)();
    // we cannot add `customizeProduct` as a depedency or else it will create an infinite render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedPopularItem,
        menuCategories
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        // Ensure we're not on a location that's marked as inactive
        // @ts-expect-error ensure `detail` is defined.
        (0,utils_locations/* checkLocationStatus */.uD)(locations.detail);
        var lastUpdatedLocationAt = document.head.querySelector('meta[name="location:last-updated-at"]');
        if (((ref = locations.detail) === null || ref === void 0 ? void 0 : ref.id) && lastUpdatedLocationAt) {
            dispatch(locations_actions/* locationsActions.fetchLocationIfModified */.b.fetchLocationIfModified(locations.detail.id, lastUpdatedLocationAt.content));
        }
        // Trigger product modal
        var validCategory = menuCategories.find(function(category) {
            return category.id === routeParams.catId;
        });
        if (validCategory) {
            var validProduct = validCategory.products.find(function(product) {
                return product.id === routeParams.productId;
            });
            if (validProduct) {
                customizeProduct(validProduct, validCategory, true);
            }
        }
        // Assemble koalaMetadata object, if necessary
        var koalaMetadata = {};
        // Table number from query params
        var table_number = router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.table_number;
        if (table_number) {
            if (Array.isArray(table_number)) {
                koalaMetadata.table_number = table_number[0];
            } else {
                koalaMetadata.table_number = table_number;
            }
        }
        // Location ID and label
        if (!basket.location.id) {
            // @ts-expect-error differentiate between `null` and `undefined`.
            koalaMetadata.location_id = locations.detail.id;
            koalaMetadata.location_label = routeParams.name;
            // @ts-expect-error differentiate between `null` and `undefined`.
            koalaMetadata.location_brand_id = locations.detail.brand_id;
        }
        // If koalaMetadata has keys, write them to session storage
        if (Object.keys(koalaMetadata).length > 0) {
            sessionStorage.setItem(global/* KOALA_SESSION_STORAGE_KEYS.METADATA */.iy.METADATA, JSON.stringify(koalaMetadata));
        }
        // KA Event
        (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.STORE__MENU_VIEW */.x.STORE__MENU_VIEW, {
            name: routeParams.name,
            // @ts-expect-error differentiate between `null` and `undefined`.
            details: locations.detail.id.toString()
        });
    }, []);
    (0,react.useEffect)(function() {
        /** @TODO ensure that `detail` is defined. */ // @ts-expect-error
        (0,utils_locations/* checkLocationStatus */.uD)(locations.detail);
        verifyFulfillmentAddress();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(render/* Render */.H, {
                condition: !hasAvailableProducts,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreHero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyMenu, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(render/* Render */.H, {
                condition: hasAvailableProducts,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopStoreBanner, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreBanner, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreHero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                        featureFlag: features/* FEATURE_FLAGS.STORE__MENU_SEARCH */.y8.STORE__MENU_SEARCH,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMobileMenuSearch, {
                            className: cssClassNames/* CSS_CLASSES.STORE_MENU.MENU_SEARCH_MOBILE */.Y.STORE_MENU.MENU_SEARCH_MOBILE,
                            foodHallEnabled: foodHallEnabled,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuSearch, {
                                onSelect: customizeProduct,
                                isMobile: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                        condition: foodHallEnabled,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterNavigation, {
                            menuCategories: menuCategories
                        })
                    }),
                    ((ref2 = locations.detail) === null || ref2 === void 0 ? void 0 : ref2.id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(details_Container, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuNavigation, {
                                categories: menuCategories,
                                activeTagIds: activeTagIds,
                                locationDetail: locations.detail
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuLayout, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                                                featureFlag: [
                                                    features/* FEATURE_FLAGS.STORE__MENU_SEARCH */.y8.STORE__MENU_SEARCH,
                                                    features/* FEATURE_FLAGS.STORE__DIETARY_PREFERENCES */.y8.STORE__DIETARY_PREFERENCES, 
                                                ],
                                                flagRelationship: features/* FLAG_RELATIONSHIP.OR */.Az.OR,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMenuLayoutHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                                                            featureFlag: features/* FEATURE_FLAGS.STORE__MENU_SEARCH */.y8.STORE__MENU_SEARCH,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroMenuSearch, {
                                                                className: cssClassNames/* CSS_CLASSES.STORE_MENU.MENU_SEARCH */.Y.STORE_MENU.MENU_SEARCH,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuSearch, {
                                                                    onSelect: customizeProduct
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                                                            featureFlag: features/* FEATURE_FLAGS.STORE__DIETARY_PREFERENCES */.y8.STORE__DIETARY_PREFERENCES,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(allergens/* AllergensModal */.C, {
                                                                maxWidth: 875,
                                                                fromTop: 30,
                                                                displayOnMobile: false
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
                                                featureFlag: features/* FEATURE_FLAGS.ME__REORDER */.y8.ME__REORDER,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStoreReorders, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* ReorderList */.L, {
                                                        /** @TODO ensure that `detail` is defined. */ locationID: locations.detail.id,
                                                        ordersToDisplay: 3,
                                                        collapsible: false
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularItems, {
                                                location: locations,
                                                menuCategories: menuCategories
                                            }),
                                            (!foodHallEnabled || activeTagIds) && menuCategories && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuCategories, {
                                                categories: menuCategories,
                                                customizeProduct: customizeProduct,
                                                currentCategory: routeParams.catId,
                                                activeTagIds: activeTagIds
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimers, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cartReconciliation, {
                        menuCategories: menuCategories,
                        menuLoading: isLoading
                    }),
                    webConfig.store_banner.placement === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomStoreBanner, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreBanner, {})
                    }),
                    (0,stringHelpers/* safelyGetString */.bc)(strings, "store.back_to_top_cta") && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTopCTA, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLoading, {
                        isVisible: isLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Loading */.Z.Loading, {})
                    })
                ]
            })
        ]
    });
}
var details_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dcbdc12e-0"
})(details_templateObject(), function(param) {
    var theme = param.theme;
    return theme.menu_categories.category_nav_display === CATEGORY_NAV_DISPLAY.LEFT && "\n      display: grid;\n      grid-template-columns: minmax(14rem, 18rem) 1fr;\n\n      > div:first-child {\n        width: ".concat(constants_styles/* LAYOUT.LEFT_CATEGORY_NAV_MAX_WIDTH */._.LEFT_CATEGORY_NAV_MAX_WIDTH, "px;\n        min-width: ").concat(constants_styles/* LAYOUT.LEFT_CATEGORY_NAV_MIN_WIDTH */._.LEFT_CATEGORY_NAV_MIN_WIDTH, "px;\n        overflow-y: auto;\n        position: sticky;\n        top: ").concat(constants_styles/* LAYOUT.HEADERHEIGHT */._.HEADERHEIGHT, "px;\n        align-self: flex-start;\n        min-height: calc(100vh - ").concat(constants_styles/* LAYOUT.HEADERHEIGHT */._.HEADERHEIGHT, "px);\n        justify-content: left;\n      }\n    ");
});
function getBackgroundRepeatValue(value) {
    var map = {
        none: "no-repeat",
        vertical: "repeat-y",
        horizontal: "repeat-x",
        repeat: "repeat"
    };
    return map[value];
}
var MenuLayout = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    "data-css-override": "StyledMenuLayout"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundImage: theme.menu.background.image ? "url(".concat((0,imageHelper/* resizeImage */.tg)(theme.menu.background.image, {
            width: 1800
        }), ")") : "none",
        backgroundSize: theme.menu.background.size,
        backgroundRepeat: getBackgroundRepeatValue(theme.menu.background.repeat),
        backgroundAttachment: theme.menu.background.attachment,
        backgroundPosition: "".concat(theme.menu.background.horizontal_position, " ").concat(theme.menu.background.vertical_position),
        margin: "0 auto",
        padding: "var(--size-3) var(--size-4)",
        width: "100%",
        "@media screen and (min-width: 768px)": {
            flex: "1 1 auto",
            gap: "var(--size-8)",
            padding: "var(--size-8)",
            overflow: "hidden"
        },
        "@media screen and (min-width: 1024px)": {
            padding: "var(--size-12) var(--size-16)"
        },
        "& > div:first-child": {
            display: "flex",
            flexDirection: "column",
            gap: "var(--size-6)",
            margin: "0 auto",
            maxWidth: "var(--size-4xl)",
            "@media screen and (min-width: 1024px)": {
                gap: "var(--size-12)"
            }
        },
        "& > h1": {
            fontSize: "24px"
        },
        "& > p": {
            fontSize: "16px"
        }
    };
});
var details_primary_border_color;
var MenuLoading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dcbdc12e-1"
})(function(param) {
    var theme = param.theme, isVisible = param.isVisible;
    return {
        alignItems: "center",
        backgroundColor: theme.global.body_color,
        border: "1px solid",
        borderColor: (details_primary_border_color = theme.global.primary_border_color) !== null && details_primary_border_color !== void 0 ? details_primary_border_color : "transparent",
        boxShadow: "0px 0px 8px 0px rgb(15 15 15 / 0.19)",
        bottom: "1.25rem",
        color: theme.global.primary_active_color,
        display: "flex",
        borderRadius: "50%",
        right: "1.25rem",
        height: "3rem",
        justifyContent: "center",
        position: "fixed",
        transform: isVisible ? "translateY(calc(var(--safe-offset--descending, 0) * -1))" : "translateY(10rem)",
        transition: "all 0.4s ease",
        width: "3rem",
        zIndex: 10
    };
});

// EXTERNAL MODULE: ./src/redux/allergens/actions.ts
var allergens_actions = __webpack_require__(92153);
// EXTERNAL MODULE: ./src/redux/store.ts + 51 modules
var store = __webpack_require__(36429);
// EXTERNAL MODULE: ./src/services/footer.service.ts
var footer_service = __webpack_require__(77203);
// EXTERNAL MODULE: ./src/services/locations.service.ts
var locations_service = __webpack_require__(19658);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/hydration.mjs
var hydration = __webpack_require__(78914);
;// CONCATENATED MODULE: ./src/services/ssr.service.ts



/**
 * Fetches required react-query requests on the server
 * #### Example request:
 * ```ts
 * queryOnServer([{
 *  queryKey: ["site-footer"],
 *  queryFn: getFooterTemplate
 * }])
 * ```
 * @param locationId a store location id
 * @param maxItems a maximum amount of items (api maximum is 50)
 * @returns `Promise<DehydratedState>`
 */ function queryOnServer(queries, queryClient) {
    return _queryOnServer.apply(this, arguments);
}
function _queryOnServer() {
    _queryOnServer = (0,_async_to_generator/* default */.Z)(function(queries, queryClient) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // this allows us to map over each query and wait for all of them to resolve
                    // we need all of our queries to resolve before we send the dehydrated state
                    // *ideally* our routes are all heavily cached so we don't create blocking network requests on every page load
                    return [
                        4,
                        Promise.all(queries.map(function(param) {
                            var queryKey = param.queryKey, queryFn = param.queryFn;
                            // @ts-expect-error: queryFn is a function, as typed in `ServerQuery`
                            return queryClient.prefetchQuery(queryKey, queryFn, {
                                staleTime: 60000
                            });
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        (0,hydration/* dehydrate */.D)(queryClient)
                    ];
            }
        });
    });
    return _queryOnServer.apply(this, arguments);
}

;// CONCATENATED MODULE: ./pages/store/[...id].tsx



























var Store = function(param) {
    var serverState = param.serverState, routeParams = param.routeParams;
    var ref;
    var locations = (0,redux/* useSelector */.v9)(function(state) {
        return state.app;
    }).locations;
    var dispatch = (0,redux/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch(allergens_actions/* default.fetchAllergens */.Z.fetchAllergens());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        var serverStateQueries = serverState;
        var menuQueryState = null;
        serverStateQueries === null || serverStateQueries === void 0 ? void 0 : (ref = serverStateQueries.queries) === null || ref === void 0 ? void 0 : ref.forEach(function(query) {
            if ((query === null || query === void 0 ? void 0 : query.queryKey[0]) === "menu") {
                var ref, ref1;
                menuQueryState = {
                    key: query.queryHash,
                    hasProducts: (ref1 = (ref = query.state) === null || ref === void 0 ? void 0 : ref.data[0]) === null || ref1 === void 0 ? void 0 : ref1.some(function(category) {
                        return category.products.length > 0;
                    })
                };
            }
        });
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOG */.AH.LOG, {
            name: constants_events/* LOG_EVENTS.MENU_SSR_FETCHED */.yX.MENU_SSR_FETCHED,
            details: JSON.stringify(menuQueryState)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hydrate/* Hydrate */.p, {
        state: serverState,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreHead, {
                routeParams: routeParams
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
                // Don't render page if location is inactive
                disabled: ((ref = locations.detail) === null || ref === void 0 ? void 0 : ref.status_id) === constants_locations/* LOCATION_STATUSES.INACTIVE */.qX.INACTIVE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreDetails, {
                    routeParams: routeParams
                })
            })
        ]
    });
};
Store.getInitialProps = store/* wrapper.getInitialPageProps */.Y.getInitialPageProps(function(store) {
    return function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var req, query, res, origin, sdkClient, reactQueryClient, webConfig, routeParams, locationDetails, e, ref, serverRequests, state, serverState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        req = param.req, query = param.query, res = param.res;
                        if (true) {
                            origin = (0,src_utils/* getOrigin */.P$)(window.location.host);
                        } else {}
                        sdkClient = (0,services_client/* createHttpClient */.d9)({
                            origin: origin
                        });
                        reactQueryClient = new queryClient/* QueryClient */.S();
                        return [
                            4,
                            (0,v4/* getWebConfig */.IO)({
                                client: sdkClient
                            })
                        ];
                    case 1:
                        webConfig = _state.sent();
                        routeParams = (0,utils_locations/* parseLocationRouteParams */.tS)(query);
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            ,
                            11
                        ]);
                        if (!(0,config/* supportsBrandId */.i)(webConfig)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0,locations_service/* fetchLocationByBrandId */.vo)(routeParams.id, {
                                client: sdkClient
                            })
                        ];
                    case 3:
                        locationDetails = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            (0,locations_service/* fetchLocation */.Kx)({
                                id: parseInt(routeParams.id, 10)
                            }, {
                                client: sdkClient
                            })
                        ];
                    case 5:
                        /** @TODO remove the parseInt once all locationIDs are strings. */ locationDetails = _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            11
                        ];
                    case 7:
                        e = _state.sent();
                        if (!res) return [
                            3,
                            8
                        ];
                        res.writeHead(302, {
                            Location: routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE,
                            "Cache-Control": "no-cache"
                        });
                        res.end();
                        return [
                            3,
                            10
                        ];
                    case 8:
                        return [
                            4,
                            router_default().replace("/")
                        ];
                    case 9:
                        _state.sent();
                        _state.label = 10;
                    case 10:
                        return [
                            2,
                            {}
                        ];
                    case 11:
                        // Hydrate location details and fetch the location's menu
                        store.dispatch(locations_actions/* locationsActions.hydrateLocation */.b.hydrateLocation(locationDetails.data));
                        if (!req) return [
                            3,
                            13
                        ];
                        store.dispatch(redux_saga_core_npm_proxy_esm/* END */.uR);
                        return [
                            4,
                            (ref = store.sagaTask) === null || ref === void 0 ? void 0 : ref.toPromise()
                        ];
                    case 12:
                        _state.sent();
                        _state.label = 13;
                    case 13:
                        serverRequests = [
                            {
                                queryKey: [
                                    "site-footer"
                                ],
                                queryFn: function() {
                                    return (0,footer_service/* getFooterTemplate */.s)(origin);
                                }
                            },
                            {
                                queryKey: [
                                    "popular-items",
                                    {
                                        id: locationDetails.data.id,
                                        wantedAt: "asap"
                                    }
                                ],
                                queryFn: function() {
                                    return (0,v4/* getPopularProducts */.ji)({
                                        locationId: locationDetails.data.id,
                                        maxItems: 15
                                    }, {
                                        client: sdkClient
                                    });
                                }
                            },
                            {
                                queryKey: [
                                    "menu",
                                    {
                                        id: locationDetails.data.id,
                                        ifModifiedSince: undefined,
                                        wantedAt: global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP
                                    }
                                ],
                                queryFn: function() {
                                    return (0,v4/* getMenu */.r7)({
                                        id: locationDetails.data.id
                                    }, {
                                        client: sdkClient
                                    });
                                }
                            }
                        ];
                        state = store.getState();
                        if (state.app.cmsConfig.webConfig.admin.food_hall) {
                            serverRequests = serverRequests.concat([
                                {
                                    queryKey: [
                                        "food-halls"
                                    ],
                                    queryFn: function() {
                                        return (0,v4/* getTags */.NJ)({
                                            type: "filter"
                                        }, {
                                            client: sdkClient
                                        });
                                    }
                                }, 
                            ]);
                        }
                        return [
                            4,
                            queryOnServer(serverRequests, reactQueryClient)
                        ];
                    case 14:
                        serverState = _state.sent();
                        return [
                            2,
                            {
                                serverState: serverState,
                                routeParams: routeParams
                            }
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }();
});
/* harmony default export */ var _id_ = (Store);


/***/ }),

/***/ 64316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ ReorderList; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/reorders/list/styles.ts
var styles = __webpack_require__(74257);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(8782);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var primaryButton_styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
// EXTERNAL MODULE: ./src/utils/safePolished.ts
var safePolished = __webpack_require__(68902);
;// CONCATENATED MODULE: ./src/components/reorders/listItem/styles.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid\n    ",
        ";\n  border-radius: ",
        "px;\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  list-style-type: none;\n  min-width: 265px;\n  padding: var(--size-3);\n  scroll-snap-align: start;\n  width: auto;\n\n  @media (min-width: 768px) {\n    margin: 0;\n    width: 33.3333%;\n  }\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-size: 13px;\n  margin: var(--size-2) 0 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  margin: var(--size-3) 0 0;\n\n  p {\n    margin: 0;\n\n    @supports (-webkit-line-clamp: 2) {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: var(--size-3) 0 0;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var StyledReorderListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-291919f0-0"
})(_templateObject(), function(props) {
    return props.theme.global.primary_border_color;
}, function(props) {
    return props.theme.global.border_radius;
}, function(props) {
    return props.theme.location_card.background_color;
});
var ReorderHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-291919f0-1"
})(_templateObject1());
var StyledReorderDate = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-291919f0-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        margin: 0
    }, (0,utils/* getFontStyles */.l)(theme.location_card.secondary_font, [
        "color",
        "font_size"
    ]));
});
var StyledReorderConveyanceLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-291919f0-3"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        backgroundColor: theme.buttons.primary_button_background_color,
        borderRadius: "".concat(theme.buttons.primary_button_border_radius, "px"),
        fontSize: "12px",
        padding: "var(--size-1) var(--size-2)",
        whiteSpace: "nowrap"
    }, (0,utils/* getFontStyles */.l)(theme.buttons.primary_font, [
        "font_family",
        "font_weight",
        "color"
    ], {
        color: function(value) {
            if (value === "revert" || value === null) {
                return (0,safePolished/* safePolished */.F)(polished_esm/* readableColor */.XV)(theme.buttons.primary_button_background_color);
            }
            return value;
        }
    }));
});
var StyledReorderLocationLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-291919f0-4"
})(_templateObject2());
var StyledReorderMenuItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-291919f0-5"
})(_templateObject3());
var StyledReorderButton = (0,styled_components_browser_esm/* default */.ZP)(primaryButton_styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-291919f0-6"
})(_templateObject4());

// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
// EXTERNAL MODULE: ./src/constants/global.ts
var global = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/utils/basket.ts
var basket = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
;// CONCATENATED MODULE: ./src/components/reorders/listItem/index.tsx








var ReorderListItem = function(param) {
    var orderDetails = param.orderDetails, showReorderReceipt = param.showReorderReceipt;
    var ref;
    var orderConveyance = global/* API_FOR_CONVEYANCE_TYPES_SWAP */.NX[orderDetails.order_data.basket.conveyance_type.type] || dist/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReorderListItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReorderHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderDate, {
                        children: (0,utils_dates/* formatDate */.p6)(orderDetails.order_data.order.ordered_at, dates/* DATE_FORMAT.SHORT_WRITTEN_DATE */.z.SHORT_WRITTEN_DATE)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderConveyanceLabel, {
                        children: orderConveyance
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderLocationLabel, {
                children: (ref = orderDetails.store_location) === null || ref === void 0 ? void 0 : ref.label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderMenuItems, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: (0,basket/* deriveBasketItemsList */.Mf)(orderDetails.order_data.basket.basket_items)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderButton, {
                buttonTheme: "primary",
                submitting: false,
                onClick: function() {
                    showReorderReceipt(orderDetails);
                },
                "aria-label": "Reorder order #".concat(orderDetails.order_data.order.order_number),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "reorders.reorder_cta"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/reorders/viewAll/styles.ts


function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  flex-grow: var(--reorder-view-all-container__flex-grow);\n  margin: 0 0 0 auto;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledReorderViewAllContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91a2ddc1-0"
})(styles_templateObject(), function(props) {
    return "\n    --reorder-view-all-container__flex-grow: ".concat(props.expand ? "1" : "auto", ";\n  ");
});
var StyledReorderViewAll = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-91a2ddc1-1"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        textDecoration: "underline"
    }, (0,utils/* getFontStyles */.l)(theme.text.primary_font, [
        "color"
    ]));
});

// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
;// CONCATENATED MODULE: ./src/components/reorders/viewAll/index.tsx





var ViewAllReordersLink = function(props) {
    var expand = props.expand;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderViewAllContainer, {
        expand: expand,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: routes/* LOYALTY_ROUTES.ORDER_HISTORY */.xM.ORDER_HISTORY,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReorderViewAll, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "reorders.view_all_past_orders_cta"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/uielements/historyIcon/index.tsx


var _HistoryIconSvg = function(param) {
    var color = param.color, _size = param.size, size = _size === void 0 ? 24 : _size, theme = param.theme;
    var _color;
    var fallbackColor = (_color = theme.text.primary_font.color) !== null && _color !== void 0 ? _color : "inherit";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.925 2.843a9.096 9.096 0 0 0-8.769 6.845l-.609-.921a.832.832 0 1 0-1.389.915l1.832 2.776a.902.902 0 0 0 .528.354c.217.043.443 0 .629-.121l2.747-1.85a.832.832 0 1 0-.928-1.382l-1.25.843a7.416 7.416 0 1 1 7.21 9.19 7.402 7.402 0 0 1-6.062-3.182.833.833 0 1 0-1.365.952A9.058 9.058 0 0 0 22 12a9.127 9.127 0 0 0-9.073-9.157Z",
                fill: color !== null && color !== void 0 ? color : fallbackColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.842 6.963a.833.833 0 0 0-.832.833V12c.003.22.09.43.244.588l2.497 2.52a.844.844 0 0 0 1.177.006.832.832 0 0 0 .005-1.177l-2.258-2.28V7.797a.833.833 0 0 0-.833-.833Z",
                fill: color !== null && color !== void 0 ? color : fallbackColor
            })
        ]
    });
};
var HistoryIconSvg = (0,styled_components_browser_esm/* withTheme */.Zz)(_HistoryIconSvg);

// EXTERNAL MODULE: ./src/components/uielements/stack/stack.tsx + 2 modules
var stack = __webpack_require__(45866);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/utils/orders.ts
var orders = __webpack_require__(40274);
;// CONCATENATED MODULE: ./src/components/reorders/list/index.tsx











var ReorderList = function(param) {
    var locationID = param.locationID, _ordersToDisplay = param.ordersToDisplay, ordersToDisplay = _ordersToDisplay === void 0 ? 3 : _ordersToDisplay, _collapsible = param.collapsible, collapsible = _collapsible === void 0 ? true : _collapsible, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon;
    var pastOrders = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.pastOrders;
    });
    var orderCompleted = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.basket.orderCompleted;
    });
    var dispatch = (0,redux/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), listCollapse = ref[0], setListCollapse = ref[1];
    var reorderListRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (orderCompleted) {
            dispatch(actions/* default.fetchMePastOrders */.Z.fetchMePastOrders());
        }
    }, [
        orderCompleted
    ]);
    /**
   * Hydrate the reorder modal details and toggle the reorder modal open
   *
   * @param orderDetails OrderDetails
   */ var hydrateAndToggleReorderModal = function(orderDetails) {
        dispatch(actions/* default.fetchMeOrderDetailsSuccess */.Z.fetchMeOrderDetailsSuccess(orderDetails));
        dispatch(actions/* default.toggleReorderReceipt */.Z.toggleReorderReceipt(true));
    };
    /**
   * Handle the collapse chevron button click
   */ var handleCollapseClick = function() {
        setListCollapse(!listCollapse);
    };
    var reorders = (0,orders/* deriveOrdersByLocationID */.WJ)(pastOrders, locationID).slice(0, ordersToDisplay);
    // Triple check we have reorders to display before showing the reorder interface
    // (This is applicable in scenarios where a user has past orders but none for a specific store)
    if (!reorders.length) {
        return null;
    }
    var ariaControlsID = "recent-orders";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: reorderListRef,
        className: "koala__ui-reorders-container-div",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.K, {
                overrides: {
                    margin: "var(--size-4) 0"
                },
                children: [
                    showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryIconSvg, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: styles/* StyledReorderHeading */.rS,
                        accessor: "reorders.recent_orders_title"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewAllReordersLink, {
                        expand: collapsible
                    }),
                    collapsible && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledCollapseButton */.SR, {
                        onClick: function() {
                            return handleCollapseClick();
                        },
                        invert: listCollapse,
                        "aria-expanded": !listCollapse,
                        "aria-controls": ariaControlsID,
                        id: "controls-".concat(ariaControlsID)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledCollapsibleContainer */.xd, {
                collapse: listCollapse,
                role: "region",
                tabIndex: -1,
                id: ariaControlsID,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* StyledReorderList */.ck, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ReorderListPadding */.b$, {}),
                        reorders.map(function(order, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReorderListItem, {
                                orderDetails: order,
                                showReorderReceipt: hydrateAndToggleReorderModal
                            }, "".concat(order.id, "-").concat(i));
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ReorderListPadding */.b$, {})
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 74257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SR": function() { return /* binding */ StyledCollapseButton; },
/* harmony export */   "b$": function() { return /* binding */ ReorderListPadding; },
/* harmony export */   "ck": function() { return /* binding */ StyledReorderList; },
/* harmony export */   "rS": function() { return /* binding */ StyledReorderHeading; },
/* harmony export */   "xd": function() { return /* binding */ StyledCollapsibleContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73393);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 300px;\n  transition: max-height ",
        " ease-in-out, visibility 0s 0s;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: var(--size-2);\n  margin: 0 var(--neg-size-5) 0 var(--neg-size-5);\n  padding: 0;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    -webkit-appearance: none;\n    display: none;\n    height: 0;\n    width: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: var(--size-1);\n  position: relative;\n\n  &::after {\n    content: "";\n    display: block;\n    position: relative;\n    height: ',
        "px;\n    border-bottom: 1.5px solid\n      ",
        ";\n    border-right: 1.5px solid\n      ",
        ";\n    transform: rotate(225deg) translateX(-25%) translateY(-25%);\n    transition: transform ",
        " ease-in-out;\n    width: ",
        "px;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 0 0 var(--size-3);\n  height: var(--size-5);\n  scroll-snap-align: start;\n  list-style-type: none;\n  width: var(--size-3);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var LIST_TRANSITION_TIME = "0.35s";
var StyledCollapsibleContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-68e04783-0"
})(_templateObject(), LIST_TRANSITION_TIME, function(props) {
    return props.collapse && "\n    max-height: 0px;\n    visibility: hidden;\n    transition: max-height ".concat(LIST_TRANSITION_TIME, " ease-in-out, visibility 0s ").concat(LIST_TRANSITION_TIME, ";\n  ");
});
var StyledReorderList = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-68e04783-1"
})(_templateObject1());
var StyledReorderHeading = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-68e04783-2"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        margin: 0
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFontStyles */ .l)(theme.location_search.tertiary_font, [
        "color",
        "font_family",
        "font_size", 
    ]));
});
var StyledCollapseButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-68e04783-3"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .SPACING_SCALE.XS */ .jl.XS, function(props) {
    return props.theme.global.primary_active_color;
}, function(props) {
    return props.theme.global.primary_active_color;
}, LIST_TRANSITION_TIME, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .SPACING_SCALE.XS */ .jl.XS, function(props) {
    return props.invert && "\n      transform: rotate(45deg);\n    ";
});
var ReorderListPadding = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-68e04783-4"
})(_templateObject3());


/***/ }),

/***/ 27252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ChevronDown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73393);



// @DESIGN-IMPLEMENTATION-TODO - add additional chevrons and size variants, deprecate old chevron
var _ChevronDown = function(param) {
    var color = param.color, theme = param.theme;
    var ref = (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_1__/* .getFontStyles */ .l)(theme.modals.font), fallbackColor = ref.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "10",
        viewBox: "0 0 16 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.58638 9.74342L15.785 1.55458C16.0791 1.19608 16.0704 0.637421 15.7654 0.290927C15.4603 -0.0555668 14.9685 -0.065424 14.6529 0.268631L8.00964 7.81449L1.36639 0.268631C1.2169 0.0967426 1.01304 0 0.800329 0C0.587615 0 0.383757 0.0967426 0.234265 0.268631C-0.0780888 0.623866 -0.0780888 1.19935 0.234265 1.55458L7.47561 9.74342C7.78462 10.0855 8.27738 10.0855 8.58638 9.74342Z",
            fill: color !== null && color !== void 0 ? color : fallbackColor
        })
    });
};
var ChevronDown = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .withTheme */ .Zz)(_ChevronDown);


/***/ }),

/***/ 7987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ usePopularItems; }
/* harmony export */ });
/* harmony import */ var _koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40024);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47661);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86879);
/* harmony import */ var _services_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49741);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32210);
/* harmony import */ var _utils_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);






/**
 * An api segment hook for fetching popular items for a specified location
 * ```
 * const { response, count, title, getProduct } = usePopularItems({ location: 1 });
 * ```
 */ function usePopularItems(param) {
    var location = param.location, wantedAt = param.wantedAt, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 15 : _maxItems;
    var ref, ref1;
    var ref2 = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.webConfig.menu;
    }), showPopularItems = ref2.popular_products;
    var ref3 = (0,_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.app.cmsConfig.strings.store;
    }), popularItemsHeader = ref3.popular_products_header;
    /**
   * Make sure that `usePopularItems` is prefetched before
   * this component renders, otherwise it will explode!
   * @see __DANGEROUS_EMPTY_REQUEST_ORIGIN
   */ var origin;
    if (true) {
        origin = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getOrigin */ .P$)(window.location.host);
    } else {}
    var response = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a)({
        queryKey: [
            "popular-items",
            {
                id: location !== null && location !== void 0 ? location : 0,
                wantedAt: wantedAt !== null && wantedAt !== void 0 ? wantedAt : "asap"
            }, 
        ],
        queryFn: function() {
            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getPopularProducts */ .ji)({
                locationId: location !== null && location !== void 0 ? location : 0,
                maxItems: maxItems,
                wantedAt: wantedAt
            }, {
                client: (0,_services_client__WEBPACK_IMPORTED_MODULE_2__/* .createHttpClient */ .d9)({
                    origin: origin
                })
            });
        },
        enabled: showPopularItems && location !== null,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        keepPreviousData: true
    });
    var ref4;
    return {
        response: response,
        count: (ref4 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref4 !== void 0 ? ref4 : 0,
        title: popularItemsHeader,
        enabled: showPopularItems,
        getItem: function getItem(product) {
            // popular products return a product array of 1 product
            return (0,_utils_menu__WEBPACK_IMPORTED_MODULE_4__/* .augmentMenuProduct */ .P_)(product.products[0]);
        }
    };
}


/***/ }),

/***/ 18827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Widget; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./src/components/content/stitches.ts
var stitches = __webpack_require__(65465);
// EXTERNAL MODULE: ./src/components/ui/index.ts + 5 modules
var ui = __webpack_require__(49586);
// EXTERNAL MODULE: ./src/components/uielements/render.tsx
var render = __webpack_require__(45190);
// EXTERNAL MODULE: ./src/redux/cmsConfig/index.ts
var cmsConfig = __webpack_require__(26738);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/features/popular-items/card.tsx







function Card(param) {
    var image = param.image, name = param.name, description = param.description, calories = param.calories, price = param.price, onClick = param.onClick;
    var ref = (0,cmsConfig/* useConfigOverride */.$E)("global"), primary_border_color = ref.primary_border_color, border_radius = ref.border_radius;
    var primary_font = (0,cmsConfig/* useConfigOverride */.$E)("text").primary_font;
    var color = (0,utils/* getFontStyles */.l)(primary_font).color;
    var ref1 = (0,cmsConfig/* useConfigOverride */.$E)("menu_product_card"), hide_calories = ref1.hide_calories, hide_price = ref1.hide_price, hide_description = ref1.hide_description, hide_description_mobile = ref1.hide_description_mobile, hide_image = ref1.hide_image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        onClick: onClick,
        direction: "vertical",
        css: {
            border: "1px solid ".concat(primary_border_color),
            borderRadius: "".concat(border_radius, "px"),
            color: color
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: !hide_image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                    children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        src: image,
                        alt: name
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                css: {
                    flex: "1 0 0",
                    fontSize: "$text200",
                    padding: "$3 $2 $6"
                },
                direction: "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                        condition: !hide_description,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            hideOnMobile: hide_description_mobile,
                            children: description
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                        css: {
                            gap: 0,
                            marginTop: "auto",
                            flexDirection: "column",
                            "@sm": {
                                flexDirection: "row",
                                gap: "$2"
                            }
                        },
                        position: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: !hide_price,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: price
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                                condition: !hide_calories,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: calories
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var ImageContainer = (0,stitches/* styled */.zo)("div", {
    aspectRatio: "1 / 1",
    backgroundColor: "$shade200",
    overflow: "hidden",
    transition: "all .4s ease",
    width: "100%"
});
var Image = (0,stitches/* styled */.zo)("img", {
    display: "block",
    height: "100%",
    objectFit: "cover",
    transition: "all .4s ease",
    width: "100%",
    maxWidth: 300
});
var Content = (0,stitches/* styled */.zo)(ui/* Stack */.Kq, {
    transition: "all .2s ease"
});
var Title = (0,stitches/* styled */.zo)("h3", {
    fontSize: "1rem",
    margin: 0
});
var Description = (0,stitches/* styled */.zo)("p", {
    margin: 0,
    variants: {
        hideOnMobile: {
            false: {
                display: "block"
            },
            true: {
                display: "none",
                "@md": {
                    display: "block"
                }
            }
        }
    }
});
var _obj;
var Container = (0,stitches/* styled */.zo)(ui/* Stack */.Kq, (_obj = {
    cursor: "pointer",
    height: "100%",
    overflow: "hidden",
    textAlign: "center",
    transition: "all .4s ease",
    transform: "translate3d(0,0,0)"
}, (0,_define_property/* default */.Z)(_obj, "&:hover ".concat(Image), {
    transform: "scale(1.1)"
}), (0,_define_property/* default */.Z)(_obj, "&:hover ".concat(ImageContainer), {
    backgroundColor: "$shade300"
}), _obj));

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/components/ui/use-slider/use-slider.tsx

/**
 * Encapsulates generic slider functionality used in various components
 * The goal of this hook is to handle basic slider requirements while not
 * dictating the UI.
 *
 * At the basic level, the [*]Prop objects (including dots) are all thats required to use this hook
 *
 * ```
 * const { backProps, nextProps, itemProps, dots } = useSlider({count: 12, perPage: 5});
 * ```
 * @param {Props} props.count the total number of items
 * @param {Props} props.perPage the number of items to show per page (slide)
 */ function useSlider(param) {
    var count = param.count, _perPage = param.perPage, perPage = _perPage === void 0 ? 1 : _perPage;
    var goBack = function goBack() {
        setPage(function(state) {
            if (disablePrevious) {
                return state;
            }
            // return state > 0 ? state - 1 : 0;
            return state - 1;
        });
    };
    var goForward = function goForward() {
        setPage(function(state) {
            if (disableNext) {
                return state;
            }
            return state + 1;
        });
    };
    var ref = (0,react.useState)(0), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(true), disablePrevious = ref1[0], setDisablePrevious = ref1[1];
    var ref2 = (0,react.useState)(true), disableNext = ref2[0], setDisableNext = ref2[1];
    var ref3 = (0,react.useState)(0), offset = ref3[0], setOffset = ref3[1];
    var ref4 = (0,react.useState)(Math.ceil(count / perPage)), pages = ref4[0], setPages = ref4[1];
    (0,react.useEffect)(function() {
        var isFirstPage = page === 0;
        var isLastPage = page === pages - 1;
        setDisablePrevious(isFirstPage ? true : false);
        setDisableNext(isLastPage ? true : false);
        if (count <= perPage) {
            return;
        }
        if (isLastPage && count % perPage !== 0) {
            /*
       * This hook allows us to show multiple items per page.
       * For example, 15 total items with 5 per page will have 3 pages
       *
       * However, if there is a remainder (ie: 12 total items with 5 per page),
       * we don't want to show a gap on the last page the end.
       *
       * This check uses the `%` modulo operator to grab the difference (12%5 = 2)
       * and calculate the correct final offset
       *
       * Note: this doesn't work when we have a remainder of 0,
       * hence the if condition above to exclude even sets.
       *
       */ setOffset((page * perPage - (perPage - count % perPage)) * -100);
        } else {
            setOffset(page * perPage * -100); // each item is treated individually, so we offset the full value
        }
    }, [
        page,
        count,
        perPage,
        pages
    ]);
    (0,react.useEffect)(function() {
        setPages(Math.ceil(count / perPage));
    }, [
        count,
        perPage
    ]);
    return {
        // spread over the button that controls going back a page
        backProps: {
            onClick: goBack,
            disabled: disablePrevious
        },
        // spread over the button that controls going forward a page
        nextProps: {
            onClick: goForward,
            disabled: disableNext
        },
        // spread over each item, all items should be in a straight list
        // with the appropriate css applied based on the requirements
        // see: popular products widget as an example
        itemProps: {
            style: {
                transform: "translateX(".concat(offset, "%)")
            }
        },
        // map over and spread props to each dot button. Apply the label as the button label
        dots: Array.from(Array(pages).keys()).map(function(item) {
            return {
                label: item + 1,
                props: {
                    onClick: function() {
                        return setPage(item);
                    },
                    active: Boolean(page === item)
                }
            };
        }),
        // exposed low level operations for unique situations
        pages: pages,
        page: page,
        setPage: setPage
    };
}

// EXTERNAL MODULE: ./src/components/uielements/icon/index.tsx + 20 modules
var icon = __webpack_require__(98414);
// EXTERNAL MODULE: ./src/utils/imageHelper.ts
var imageHelper = __webpack_require__(70595);
;// CONCATENATED MODULE: ./src/features/popular-items/widget.tsx










function Widget(param) {
    var children = param.children, items = param.items, count = param.count, onClick = param.onClick;
    /*
   * The slider hook can be configured with:
   * - an item count
   * - a per page value (useful for complex sliders with multiple items in one slide, defaults to 1)
   */ var ref = useSlider({
        count: count,
        perPage: 5
    }), backProps = ref.backProps, nextProps = ref.nextProps, itemProps = ref.itemProps, dots = ref.dots;
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(widget_Container, {
        "data-testid": "popular-items-widget",
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: count > 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                    "data-testid": "popular-items-widget-controls",
                    css: {
                        display: "none",
                        "@lg": {
                            display: "block"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                        align: "center",
                        position: "trailing",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderNav, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, backProps), {
                                css: {
                                    transform: "rotate(180deg)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Caret */.Z.Caret, {
                                    title: "previous"
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderNav, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default.Caret */.Z.Caret, {
                                    title: "next"
                                })
                            }))
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                css: {
                    margin: "0 -$3",
                    "@md": {
                        margin: "0 -$8"
                    },
                    "@lg": {
                        margin: "0 -$3"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Stack */.Kq, {
                    align: "fill",
                    gap: "0",
                    css: {
                        overflow: "scroll",
                        padding: "$7 0 0",
                        scrollSnapType: "x mandatory",
                        scrollbarWidth: "none",
                        "-ms-overflow-style": "none",
                        "&::-webkit-scrollbar": {
                            "-webkit-appearance": "none",
                            display: "none",
                            height: 0,
                            width: 0
                        },
                        "@lg": {
                            justifyContent: count > 5 ? "flex-start" : "center",
                            overflow: "hidden"
                        }
                    },
                    children: [
                        items.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                                "data-testid": "popular-items-widget-card",
                                css: {
                                    transition: "transform 0.6s ease",
                                    "@lg": (0,_object_spread/* default */.Z)({}, itemProps.style)
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                    image: (0,imageHelper/* getProductImageSrc */.Wr)(item, {
                                        width: 300
                                    }),
                                    name: item.name,
                                    description: item.description,
                                    calories: item.pretty_calories,
                                    price: item.pretty_price,
                                    onClick: function() {
                                        return onClick(item, index);
                                    }
                                })
                            }, item.id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                            css: {
                                width: "$1",
                                "@lg": {
                                    display: "none"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(render/* Render */.H, {
                condition: count > 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Box */.xu, {
                    css: {
                        display: "none",
                        "@lg": {
                            display: "block"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Stack */.Kq, {
                        position: "center",
                        gap: "$6",
                        css: {
                            padding: "$8 0 0",
                            "@lg": {
                                padding: "$12 0 0"
                            }
                        },
                        children: dots.map(function(dot, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderDot, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dot.props), {
                                children: dot.label
                            }), index);
                        })
                    })
                })
            })
        ]
    });
}
var widget_Container = (0,stitches/* styled */.zo)("div", {
    textAlign: "center"
});
var CardWrapper = (0,stitches/* styled */.zo)("div", {
    flex: "none",
    padding: "0 0 0 $2",
    scrollSnapAlign: "start",
    width: "40%",
    "@sm": {
        padding: "0 0 0 $4",
        width: "30%"
    },
    "@lg": {
        padding: "0 $3",
        width: "20%"
    }
});
var SliderNav = (0,stitches/* styled */.zo)("button", {
    all: "unset",
    borderRadius: "$sm",
    cursor: "pointer",
    svg: {
        display: "block"
    },
    "&:focus": {
        backgroundColor: "rgba(0,0,0,.08)"
    },
    variants: {
        disabled: {
            true: {
                cursor: "default",
                opacity: 0.2
            }
        }
    }
});
var SliderDot = (0,stitches/* styled */.zo)("button", {
    all: "unset",
    backgroundColor: "$accentPrimary",
    borderRadius: "100%",
    color: "$accentPrimary",
    height: "$3",
    opacity: 0.1,
    overflow: "hidden",
    transition: "all .2s ease",
    width: "$3",
    variants: {
        active: {
            true: {
                opacity: 1,
                "&:hover, &:focus": {
                    opacity: 1
                }
            }
        }
    },
    "&:hover": {
        opacity: 0.5
    },
    "&:focus": {
        boxShadow: "0 0 0 2px white, 0 0 0 4px currentColor",
        opacity: 0.5
    },
    "@lg": {
        cursor: "pointer"
    }
});


/***/ }),

/***/ 78914:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ dehydrate; },
/* harmony export */   "ZB": function() { return /* binding */ hydrate; }
/* harmony export */ });
/* unused harmony exports defaultShouldDehydrateMutation, defaultShouldDehydrateQuery */
// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}
function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}
function dehydrate(client, options = {}) {
  const mutations = [];
  const queries = [];

  if (options.dehydrateMutations !== false) {
    const shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(mutation => {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (options.dehydrateQueries !== false) {
    const shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(query => {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations,
    queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  const mutationCache = client.getMutationCache();
  const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  const queries = dehydratedState.queries || [];
  mutations.forEach(dehydratedMutation => {
    var _options$defaultOptio;

    mutationCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations),
      mutationKey: dehydratedMutation.mutationKey
    }, dehydratedMutation.state);
  });
  queries.forEach(dehydratedQuery => {
    var _options$defaultOptio2;

    const query = queryCache.get(dehydratedQuery.queryHash); // Reset fetch status to idle in the dehydrated state to avoid
    // query being stuck in fetching state upon hydration

    const dehydratedQueryState = { ...dehydratedQuery.state,
      fetchStatus: 'idle'
    }; // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQueryState.dataUpdatedAt) {
        query.setState(dehydratedQueryState);
      }

      return;
    } // Restore query


    queryCache.build(client, { ...(options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries),
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }, dehydratedQueryState);
  });
}


//# sourceMappingURL=hydration.mjs.map


/***/ }),

/***/ 55464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Hydrate; }
/* harmony export */ });
/* unused harmony export useHydrate */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78914);
/* harmony import */ var _QueryClientProvider_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55830);
'use client';




function useHydrate(state, options = {}) {
  const queryClient = (0,_QueryClientProvider_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useQueryClient */ .NL)({
    context: options.context
  });
  const optionsRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (state) {
      (0,_tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__/* .hydrate */ .ZB)(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}
const Hydrate = ({
  children,
  options,
  state
}) => {
  useHydrate(state, options);
  return children;
};


//# sourceMappingURL=Hydrate.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [669,182,513,372,124,588,356,774,888,179], function() { return __webpack_exec__(26528); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);